//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import { trace, context, TraceFlags, Span } from '@opentelemetry/api';

import { ClientBase } from './client-base';
import { inject } from 'aurelia-framework';
import { HttpClient, RequestInit } from 'aurelia-fetch-client';

export class PolicyClientBase extends ClientBase {
  getBaseUrl(_defaultUrl: string, _baseUrl: string) {
    return this.apiService.getServiceUrl('policy-api');
  }
}

@inject(String, HttpClient)
export class CompaniesClient extends PolicyClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("CompaniesClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5910", baseUrl);
    }

    async getAll(): Promise<CustomerViewModel[]> {
        const span = this.tracer.startSpan("GET /Companies", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Companies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetAll(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetAll(response: Response): Promise<CustomerViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerViewModel[]>(null as any);
    }

    async get(companyIdentityId: number): Promise<CustomerViewModel> {
        const span = this.tracer.startSpan("GET /Companies/{companyIdentityId}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Companies/{companyIdentityId}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<CustomerViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerViewModel>(null as any);
    }

    async isNameUnique(id: number | undefined, name: string | undefined): Promise<boolean> {
        const span = this.tracer.startSpan("GET /Companies/IsNameUnique", {
            attributes: {
                "id": id,
                "name": name,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Companies/IsNameUnique?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processIsNameUnique(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processIsNameUnique(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    async isCompanyEmailUnique(companyIdentityId: number, email: string | undefined): Promise<boolean> {
        const span = this.tracer.startSpan("GET /Companies/{companyIdentityId}/IsCompanyEmailUnique", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "email": email,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Companies/{companyIdentityId}/IsCompanyEmailUnique?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processIsCompanyEmailUnique(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processIsCompanyEmailUnique(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    async isVatUnique(id: number | undefined, vat: string | undefined): Promise<boolean> {
        const span = this.tracer.startSpan("GET /Companies/IsVatUnique", {
            attributes: {
                "id": id,
                "vat": vat,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Companies/IsVatUnique?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (vat === null)
            throw new globalThis.Error("The parameter 'vat' cannot be null.");
        else if (vat !== undefined)
            url_ += "vat=" + encodeURIComponent("" + vat) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processIsVatUnique(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processIsVatUnique(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    async syncAllCompanies(): Promise<void> {
        const span = this.tracer.startSpan("GET /Companies/SyncAllCompanies", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Companies/SyncAllCompanies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processSyncAllCompanies(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processSyncAllCompanies(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async instrumentTypes(companyIdentityId: number): Promise<InstrumentType[]> {
        const span = this.tracer.startSpan("GET /Companies/{companyIdentityId}/InstrumentTypes", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Companies/{companyIdentityId}/InstrumentTypes";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processInstrumentTypes(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processInstrumentTypes(response: Response): Promise<InstrumentType[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentType[]>(null as any);
    }
}

@inject(String, HttpClient)
export class CorporationsClient extends PolicyClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("CorporationsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5910", baseUrl);
    }

    async get(): Promise<Corporation[]> {
        const span = this.tracer.startSpan("GET /Corporations", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Corporations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<Corporation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Corporation.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Corporation[]>(null as any);
    }

    async create(request: CreateCorporationRequest): Promise<string> {
        const span = this.tracer.startSpan("POST /Corporations", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Corporations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processCreate(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processCreate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    async companies(corporationId: string): Promise<number[]> {
        const span = this.tracer.startSpan("GET /Corporations/{corporationId}/Companies", {
            attributes: {
                "corporationId": corporationId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Corporations/{corporationId}/Companies";
        if (corporationId === undefined || corporationId === null)
            throw new globalThis.Error("The parameter 'corporationId' must be defined.");
        url_ = url_.replace("{corporationId}", encodeURIComponent("" + corporationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processCompanies(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processCompanies(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    async delete(corporationId: string): Promise<void> {
        const span = this.tracer.startSpan("DELETE /Corporations/{corporationId}", {
            attributes: {
                "corporationId": corporationId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Corporations/{corporationId}";
        if (corporationId === undefined || corporationId === null)
            throw new globalThis.Error("The parameter 'corporationId' must be defined.");
        url_ = url_.replace("{corporationId}", encodeURIComponent("" + corporationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async addCustomer(corporationId: string, companyIdentityId: number): Promise<void> {
        const span = this.tracer.startSpan("POST /Corporations/{corporationId}/Customers/{companyIdentityId}", {
            attributes: {
                "corporationId": corporationId,
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Corporations/{corporationId}/Customers/{companyIdentityId}";
        if (corporationId === undefined || corporationId === null)
            throw new globalThis.Error("The parameter 'corporationId' must be defined.");
        url_ = url_.replace("{corporationId}", encodeURIComponent("" + corporationId));
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processAddCustomer(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processAddCustomer(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async removeCustomer(companyIdentityId: number): Promise<void> {
        const span = this.tracer.startSpan("DELETE /Corporations/Customers/{companyIdentityId}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Corporations/Customers/{companyIdentityId}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processRemoveCustomer(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processRemoveCustomer(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async users(corporationId: string): Promise<number[]> {
        const span = this.tracer.startSpan("GET /Corporations/{corporationId}/Users", {
            attributes: {
                "corporationId": corporationId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Corporations/{corporationId}/Users";
        if (corporationId === undefined || corporationId === null)
            throw new globalThis.Error("The parameter 'corporationId' must be defined.");
        url_ = url_.replace("{corporationId}", encodeURIComponent("" + corporationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processUsers(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processUsers(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    async assignUser(corporationId: string, userId: number): Promise<void> {
        const span = this.tracer.startSpan("POST /Corporations/{corporationId}/Users/{userId}", {
            attributes: {
                "corporationId": corporationId,
                "userId": userId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Corporations/{corporationId}/Users/{userId}";
        if (corporationId === undefined || corporationId === null)
            throw new globalThis.Error("The parameter 'corporationId' must be defined.");
        url_ = url_.replace("{corporationId}", encodeURIComponent("" + corporationId));
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processAssignUser(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processAssignUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async removeUser(corporationId: string, userId: number): Promise<void> {
        const span = this.tracer.startSpan("DELETE /Corporations/{corporationId}/Users/{userId}", {
            attributes: {
                "corporationId": corporationId,
                "userId": userId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Corporations/{corporationId}/Users/{userId}";
        if (corporationId === undefined || corporationId === null)
            throw new globalThis.Error("The parameter 'corporationId' must be defined.");
        url_ = url_.replace("{corporationId}", encodeURIComponent("" + corporationId));
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processRemoveUser(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processRemoveUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

@inject(String, HttpClient)
export class CustomerLicenseAgreementsClient extends PolicyClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("CustomerLicenseAgreementsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5910", baseUrl);
    }

    async get(): Promise<CustomerLicenseAgreement> {
        const span = this.tracer.startSpan("GET /CustomerLicenseAgreements", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/CustomerLicenseAgreements";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<CustomerLicenseAgreement> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerLicenseAgreement.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerLicenseAgreement>(null as any);
    }

    async accept(companyIdentityId: number): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/CustomerLicenseAgreements/Accept", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/CustomerLicenseAgreements/Accept";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processAccept(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processAccept(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

@inject(String, HttpClient)
export class CustomersClient extends PolicyClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("CustomersClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5910", baseUrl);
    }

    async lookup(): Promise<CustomerLookupViewModel[]> {
        const span = this.tracer.startSpan("GET /companies/Lookup", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/Lookup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processLookup(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processLookup(response: Response): Promise<CustomerLookupViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerLookupViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerLookupViewModel[]>(null as any);
    }

    async myCustomers(): Promise<MyCustomerViewModel[]> {
        const span = this.tracer.startSpan("GET /companies/MyCustomers", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/MyCustomers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processMyCustomers(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processMyCustomers(response: Response): Promise<MyCustomerViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MyCustomerViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MyCustomerViewModel[]>(null as any);
    }

    async active(startDate: string | undefined, endDate: string | undefined): Promise<CustomerViewModel[]> {
        const span = this.tracer.startSpan("GET /companies/Active", {
            attributes: {
                "startDate": startDate,
                "endDate": endDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/Active?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processActive(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processActive(response: Response): Promise<CustomerViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerViewModel[]>(null as any);
    }

    async post(request: CustomerViewModel): Promise<CustomerViewModel> {
        const span = this.tracer.startSpan("POST /companies", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<CustomerViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerViewModel>(null as any);
    }

    async patch(companyIdentityId: number, request: CustomerViewModel): Promise<CustomerViewModel> {
        const span = this.tracer.startSpan("PATCH /companies/{companyIdentityId}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPatch(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPatch(response: Response): Promise<CustomerViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerViewModel>(null as any);
    }

    async delete(companyIdentityId: number, id: string | undefined): Promise<void> {
        const span = this.tracer.startSpan("DELETE /companies/{companyIdentityId}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async patchPartnerAndStatus(companyIdentityId: number, request: CustomerViewModel): Promise<CustomerViewModel> {
        const span = this.tracer.startSpan("PATCH /companies/{companyIdentityId}/PatchPartnerAndStatus", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/PatchPartnerAndStatus";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPatchPartnerAndStatus(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPatchPartnerAndStatus(response: Response): Promise<CustomerViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerViewModel>(null as any);
    }

    async patchInternalNotes(companyIdentityId: number, request: CustomerViewModel): Promise<void> {
        const span = this.tracer.startSpan("PATCH /companies/{companyIdentityId}/PatchInternalNotes", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/PatchInternalNotes";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPatchInternalNotes(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPatchInternalNotes(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async patchIntegrationSuspended(companyIdentityId: number, request: CustomerViewModel): Promise<void> {
        const span = this.tracer.startSpan("PATCH /companies/{companyIdentityId}/PatchIntegrationSuspended", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/PatchIntegrationSuspended";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPatchIntegrationSuspended(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPatchIntegrationSuspended(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async undelete(companyIdentityId: number, id: string | undefined): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Undelete", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Undelete?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processUndelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processUndelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async fetchCustomerGlTransactions(id: string): Promise<void> {
        const span = this.tracer.startSpan("GET /companies/{id}/FetchCustomerGlTransactions", {
            attributes: {
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{id}/FetchCustomerGlTransactions";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processFetchCustomerGlTransactions(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processFetchCustomerGlTransactions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Drops the company's GL transactions from reporting (Postgres and ClickHouse) and fetches them again from the
    integration. ClickHouse stays empty for the company until RebuildClickHouse is called on the reporting API,
    because the integrations do not signal when the last batch has landed.
     */
    async purgeAndResyncGlTransactions(companyIdentityId: number): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/PurgeAndResyncGlTransactions", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/PurgeAndResyncGlTransactions";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPurgeAndResyncGlTransactions(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPurgeAndResyncGlTransactions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

@inject(String, HttpClient)
export class CustomerWebhookSubscriptionsClient extends PolicyClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("CustomerWebhookSubscriptionsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5910", baseUrl);
    }

    async get(companyIdentityId: number): Promise<QueryWebhookSubscriptionResponseContract> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/CustomerWebhookSubscriptions/Get", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/CustomerWebhookSubscriptions/Get";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<QueryWebhookSubscriptionResponseContract> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryWebhookSubscriptionResponseContract.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryWebhookSubscriptionResponseContract>(null as any);
    }

    async post(companyIdentityId: number): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/CustomerWebhookSubscriptions/Post", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/CustomerWebhookSubscriptions/Post";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

@inject(String, HttpClient)
export class EndUserLicenseAgreementsClient extends PolicyClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("EndUserLicenseAgreementsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5910", baseUrl);
    }

    async get(): Promise<EndUserLicenseAgreement> {
        const span = this.tracer.startSpan("GET /EndUserLicenseAgreements", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/EndUserLicenseAgreements";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<EndUserLicenseAgreement> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EndUserLicenseAgreement.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EndUserLicenseAgreement>(null as any);
    }

    async post(request: EndUserLicenseAgreement): Promise<EndUserLicenseAgreement> {
        const span = this.tracer.startSpan("POST /EndUserLicenseAgreements", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/EndUserLicenseAgreements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<EndUserLicenseAgreement> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EndUserLicenseAgreement.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EndUserLicenseAgreement>(null as any);
    }

    async latest(): Promise<EndUserLicenseAgreement> {
        const span = this.tracer.startSpan("GET /EndUserLicenseAgreements/Latest", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/EndUserLicenseAgreements/Latest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processLatest(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processLatest(response: Response): Promise<EndUserLicenseAgreement> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EndUserLicenseAgreement.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EndUserLicenseAgreement>(null as any);
    }

    async isAccepted(): Promise<boolean> {
        const span = this.tracer.startSpan("GET /EndUserLicenseAgreements/IsAccepted", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/EndUserLicenseAgreements/IsAccepted";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processIsAccepted(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processIsAccepted(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    async accept(): Promise<void> {
        const span = this.tracer.startSpan("POST /EndUserLicenseAgreements/Accept", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/EndUserLicenseAgreements/Accept";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processAccept(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processAccept(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

@inject(String, HttpClient)
export class ExternalGlSystemsClient extends PolicyClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("ExternalGlSystemsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5910", baseUrl);
    }

    async get(): Promise<ExternalGlSystem[]> {
        const span = this.tracer.startSpan("GET /ExternalGlSystems", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/ExternalGlSystems";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<ExternalGlSystem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalGlSystem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalGlSystem[]>(null as any);
    }
}

@inject(String, HttpClient)
export class IntegrationsClient extends PolicyClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("IntegrationsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5910", baseUrl);
    }

    async get(): Promise<IntegrationSystemResponse[]> {
        const span = this.tracer.startSpan("GET /Integrations", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Integrations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<IntegrationSystemResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntegrationSystemResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IntegrationSystemResponse[]>(null as any);
    }

    async setupDefaultGlAccounts(companyIdentityId: number, reconnect: boolean | undefined): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Integrations/SetupDefaultGlAccounts", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Integrations/SetupDefaultGlAccounts?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (reconnect === null)
            throw new globalThis.Error("The parameter 'reconnect' cannot be null.");
        else if (reconnect !== undefined)
            url_ += "reconnect=" + encodeURIComponent("" + reconnect) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processSetupDefaultGlAccounts(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processSetupDefaultGlAccounts(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async validateClearIntegration(companyIdentityId: number, cutoffDate: string): Promise<ValidateClearIntegrationResponse> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Integrations/ValidateClearIntegration", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "cutoffDate": cutoffDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Integrations/ValidateClearIntegration";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cutoffDate);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processValidateClearIntegration(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processValidateClearIntegration(response: Response): Promise<ValidateClearIntegrationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateClearIntegrationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidateClearIntegrationResponse>(null as any);
    }

    async clearIntegration(companyIdentityId: number, cutoffDate: string): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Integrations/ClearIntegration", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "cutoffDate": cutoffDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Integrations/ClearIntegration";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cutoffDate);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processClearIntegration(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processClearIntegration(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets customer details from the external system
     * @param externalGlSystem (optional) Integration system identifier
     * @param apiUrl (optional) API Url
     * @param testApiUrl (optional) Test API Url
     * @param clientKey (optional) Optional client key for integrations which require it
     * @return The list of GL customers
     */
    async getIntegrationCustomerDetails(externalGlSystem: ExternalGlSystemEnum | undefined, apiUrl: string | undefined, testApiUrl: string | undefined, clientKey: string | null | undefined, companyIdentityId: string): Promise<FlowCustomerModel[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Integrations/GetIntegrationCustomerDetails", {
            attributes: {
                "apiUrl": apiUrl,
                "testApiUrl": testApiUrl,
                "clientKey": clientKey,
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Integrations/GetIntegrationCustomerDetails?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (externalGlSystem === null)
            throw new globalThis.Error("The parameter 'externalGlSystem' cannot be null.");
        else if (externalGlSystem !== undefined)
            url_ += "externalGlSystem=" + encodeURIComponent("" + externalGlSystem) + "&";
        if (apiUrl === null)
            throw new globalThis.Error("The parameter 'apiUrl' cannot be null.");
        else if (apiUrl !== undefined)
            url_ += "apiUrl=" + encodeURIComponent("" + apiUrl) + "&";
        if (testApiUrl === null)
            throw new globalThis.Error("The parameter 'testApiUrl' cannot be null.");
        else if (testApiUrl !== undefined)
            url_ += "testApiUrl=" + encodeURIComponent("" + testApiUrl) + "&";
        if (clientKey !== undefined && clientKey !== null)
            url_ += "clientKey=" + encodeURIComponent("" + clientKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetIntegrationCustomerDetails(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetIntegrationCustomerDetails(response: Response): Promise<FlowCustomerModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FlowCustomerModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FlowCustomerModel[]>(null as any);
    }

    async getSettings(companyIdentityId: number): Promise<any> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Integrations/GetSettings", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Integrations/GetSettings";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetSettings(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetSettings(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    async setSettings(companyIdentityId: number, request: any): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Integrations/SetSettings", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Integrations/SetSettings";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processSetSettings(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processSetSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async getExportFiles(companyIdentityId: number): Promise<ExportFile[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Integrations/GetExportFiles", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Integrations/GetExportFiles";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetExportFiles(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetExportFiles(response: Response): Promise<ExportFile[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExportFile.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExportFile[]>(null as any);
    }

    async downloadExportFile(companyIdentityId: number, filePath: string | undefined): Promise<FileResponse> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Integrations/DownloadExportFile", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "filePath": filePath,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Integrations/DownloadExportFile?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (filePath === null)
            throw new globalThis.Error("The parameter 'filePath' cannot be null.");
        else if (filePath !== undefined)
            url_ += "filePath=" + encodeURIComponent("" + filePath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDownloadExportFile(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDownloadExportFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

@inject(String, HttpClient)
export class InvoiceLineItemsClient extends PolicyClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("InvoiceLineItemsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5910", baseUrl);
    }

    async getByInvoice(invoiceId: number): Promise<InvoiceLineItemViewModel[]> {
        const span = this.tracer.startSpan("GET /InvoiceLineItems/invoice/{invoiceId}", {
            attributes: {
                "invoiceId": invoiceId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/InvoiceLineItems/invoice/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new globalThis.Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetByInvoice(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetByInvoice(response: Response): Promise<InvoiceLineItemViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoiceLineItemViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceLineItemViewModel[]>(null as any);
    }

    async get(id: number): Promise<InvoiceLineItemViewModel> {
        const span = this.tracer.startSpan("GET /InvoiceLineItems/{id}", {
            attributes: {
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/InvoiceLineItems/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<InvoiceLineItemViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceLineItemViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceLineItemViewModel>(null as any);
    }

    async put(id: number, request: UpdateLineItemRequest): Promise<InvoiceLineItemViewModel> {
        const span = this.tracer.startSpan("PUT /InvoiceLineItems/{id}", {
            attributes: {
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/InvoiceLineItems/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPut(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPut(response: Response): Promise<InvoiceLineItemViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceLineItemViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceLineItemViewModel>(null as any);
    }

    async delete(id: number): Promise<void> {
        const span = this.tracer.startSpan("DELETE /InvoiceLineItems/{id}", {
            attributes: {
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/InvoiceLineItems/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async post(request: CreateLineItemRequest): Promise<InvoiceLineItemViewModel> {
        const span = this.tracer.startSpan("POST /InvoiceLineItems", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/InvoiceLineItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<InvoiceLineItemViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceLineItemViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceLineItemViewModel>(null as any);
    }
}

@inject(String, HttpClient)
export class InvoiceReportingClient extends PolicyClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("InvoiceReportingClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5910", baseUrl);
    }

    /**
     * Get invoicing report with optional date and VAT filters
    Shows 1 line per license with pricing, discounts, and VAT grouping
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param vatFilter (optional) 
     */
    async getInvoicingReport(startDate: string | null | undefined, endDate: string | null | undefined, vatFilter: string | null | undefined): Promise<InvoicingReport> {
        const span = this.tracer.startSpan("GET /api/reports/InvoiceReporting/invoicing", {
            attributes: {
                "startDate": startDate,
                "endDate": endDate,
                "vatFilter": vatFilter,
            }
        }, context.active());

        let url_ = this.baseUrl + "/api/reports/InvoiceReporting/invoicing?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        if (vatFilter !== undefined && vatFilter !== null)
            url_ += "vatFilter=" + encodeURIComponent("" + vatFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetInvoicingReport(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetInvoicingReport(response: Response): Promise<InvoicingReport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoicingReport.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoicingReport>(null as any);
    }

    /**
     * Get invoicing report for specific partner
    Shows all customer licenses grouped under partner
     */
    async getInvoicingReportByPartner(partnerId: number): Promise<InvoicingReport> {
        const span = this.tracer.startSpan("GET /api/reports/InvoiceReporting/invoicing/partner/{partnerId}", {
            attributes: {
                "partnerId": partnerId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/api/reports/InvoiceReporting/invoicing/partner/{partnerId}";
        if (partnerId === undefined || partnerId === null)
            throw new globalThis.Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetInvoicingReportByPartner(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetInvoicingReportByPartner(response: Response): Promise<InvoicingReport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoicingReport.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoicingReport>(null as any);
    }

    /**
     * Get invoicing report for specific customer by UUID
    Shows all licenses for customer with their VAT numbers and owner types
     */
    async getInvoicingReportByCustomer(customerUuid: string): Promise<InvoicingReport> {
        const span = this.tracer.startSpan("GET /api/reports/InvoiceReporting/invoicing/customer/{customerUuid}", {
            attributes: {
                "customerUuid": customerUuid,
            }
        }, context.active());

        let url_ = this.baseUrl + "/api/reports/InvoiceReporting/invoicing/customer/{customerUuid}";
        if (customerUuid === undefined || customerUuid === null)
            throw new globalThis.Error("The parameter 'customerUuid' must be defined.");
        url_ = url_.replace("{customerUuid}", encodeURIComponent("" + customerUuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetInvoicingReportByCustomer(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetInvoicingReportByCustomer(response: Response): Promise<InvoicingReport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoicingReport.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoicingReport>(null as any);
    }

    /**
     * Get invoicing report for specific license
    Shows detailed breakdown of single license with package and transaction pricing
     */
    async getInvoicingReportByLicense(licenseId: number): Promise<InvoicingReport> {
        const span = this.tracer.startSpan("GET /api/reports/InvoiceReporting/invoicing/license/{licenseId}", {
            attributes: {
                "licenseId": licenseId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/api/reports/InvoiceReporting/invoicing/license/{licenseId}";
        if (licenseId === undefined || licenseId === null)
            throw new globalThis.Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetInvoicingReportByLicense(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetInvoicingReportByLicense(response: Response): Promise<InvoicingReport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoicingReport.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoicingReport>(null as any);
    }

    /**
     * Get pending invoices report
    Shows all active licenses that may require invoicing
     */
    async getPendingInvoicesReport(): Promise<InvoicingReport> {
        const span = this.tracer.startSpan("GET /api/reports/InvoiceReporting/invoicing/pending", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/api/reports/InvoiceReporting/invoicing/pending";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetPendingInvoicesReport(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetPendingInvoicesReport(response: Response): Promise<InvoicingReport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoicingReport.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoicingReport>(null as any);
    }
}

@inject(String, HttpClient)
export class InvoicesClient extends PolicyClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("InvoicesClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5910", baseUrl);
    }

    async getAll(customerUuid: string | null | undefined, partnerId: number | null | undefined, status: string | null | undefined): Promise<InvoiceViewModel[]> {
        const span = this.tracer.startSpan("GET /Invoices", {
            attributes: {
                "customerUuid": customerUuid,
                "partnerId": partnerId,
                "status": status,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Invoices?";
        if (customerUuid !== undefined && customerUuid !== null)
            url_ += "customerUuid=" + encodeURIComponent("" + customerUuid) + "&";
        if (partnerId !== undefined && partnerId !== null)
            url_ += "partnerId=" + encodeURIComponent("" + partnerId) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetAll(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetAll(response: Response): Promise<InvoiceViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoiceViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceViewModel[]>(null as any);
    }

    async get(id: number): Promise<InvoiceViewModel> {
        const span = this.tracer.startSpan("GET /Invoices/{id}", {
            attributes: {
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Invoices/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<InvoiceViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceViewModel>(null as any);
    }

    async put(id: number, request: UpdateInvoiceRequest): Promise<InvoiceViewModel> {
        const span = this.tracer.startSpan("PUT /Invoices/{id}", {
            attributes: {
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Invoices/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPut(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPut(response: Response): Promise<InvoiceViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceViewModel>(null as any);
    }

    async delete(id: number): Promise<void> {
        const span = this.tracer.startSpan("DELETE /Invoices/{id}", {
            attributes: {
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Invoices/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async getByLicense(licenseId: number): Promise<InvoiceViewModel[]> {
        const span = this.tracer.startSpan("GET /Invoices/by-license/{licenseId}", {
            attributes: {
                "licenseId": licenseId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Invoices/by-license/{licenseId}";
        if (licenseId === undefined || licenseId === null)
            throw new globalThis.Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetByLicense(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetByLicense(response: Response): Promise<InvoiceViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoiceViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceViewModel[]>(null as any);
    }

    /**
     * Preview what invoices would be generated for a given period.
    Does not create anything - read-only.
     */
    async preview(request: GenerationPeriodRequest): Promise<InvoiceGenerationPreview> {
        const span = this.tracer.startSpan("POST /Invoices/admin/preview", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Invoices/admin/preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPreview(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPreview(response: Response): Promise<InvoiceGenerationPreview> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceGenerationPreview.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceGenerationPreview>(null as any);
    }

    /**
     * Generate invoices for all eligible licenses in the given period.
    Skips licenses that already have invoices for this period.
     */
    async generate(request: GenerationPeriodRequest): Promise<GenerationResultViewModel> {
        const span = this.tracer.startSpan("POST /Invoices/admin/generate", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Invoices/admin/generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGenerate(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGenerate(response: Response): Promise<GenerationResultViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerationResultViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenerationResultViewModel>(null as any);
    }

    /**
     * Trigger an update of transaction counts.
    fullSync=false (default): only counts current month.
    fullSync=true: recomputes all historical months.
     * @param fullSync (optional) 
     */
    async updateTransactionCounts(fullSync: boolean | undefined): Promise<FileResponse> {
        const span = this.tracer.startSpan("POST /Invoices/admin/update-transaction-counts", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Invoices/admin/update-transaction-counts?";
        if (fullSync === null)
            throw new globalThis.Error("The parameter 'fullSync' cannot be null.");
        else if (fullSync !== undefined)
            url_ += "fullSync=" + encodeURIComponent("" + fullSync) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processUpdateTransactionCounts(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processUpdateTransactionCounts(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get transaction counts for a given year and month.
     * @param year (optional) 
     * @param month (optional) 
     */
    async getTransactionCounts(year: number | null | undefined, month: number | null | undefined): Promise<MonthlyTransactionCount[]> {
        const span = this.tracer.startSpan("GET /Invoices/admin/transaction-counts", {
            attributes: {
                "year": year,
                "month": month,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Invoices/admin/transaction-counts?";
        if (year !== undefined && year !== null)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month !== undefined && month !== null)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetTransactionCounts(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetTransactionCounts(response: Response): Promise<MonthlyTransactionCount[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MonthlyTransactionCount.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MonthlyTransactionCount[]>(null as any);
    }

    /**
     * Export invoices to Excel with flattened data including customer, partner, license owner, license, and package details.
    One row per line item. Supports the same filters as GetAll.
     * @param customerUuid (optional) 
     * @param partnerId (optional) 
     * @param status (optional) 
     */
    async exportExcel(customerUuid: string | null | undefined, partnerId: number | null | undefined, status: string | null | undefined): Promise<FileResponse> {
        const span = this.tracer.startSpan("GET /Invoices/admin/export-excel", {
            attributes: {
                "customerUuid": customerUuid,
                "partnerId": partnerId,
                "status": status,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Invoices/admin/export-excel?";
        if (customerUuid !== undefined && customerUuid !== null)
            url_ += "customerUuid=" + encodeURIComponent("" + customerUuid) + "&";
        if (partnerId !== undefined && partnerId !== null)
            url_ += "partnerId=" + encodeURIComponent("" + partnerId) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processExportExcel(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processExportExcel(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

@inject(String, HttpClient)
export class LicenseOwnersClient extends PolicyClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("LicenseOwnersClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5910", baseUrl);
    }

    async get(): Promise<LicenseOwner[]> {
        const span = this.tracer.startSpan("GET /LicenseOwners", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/LicenseOwners";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<LicenseOwner[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LicenseOwner.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseOwner[]>(null as any);
    }

    async create(request: CreateLicenseOwnerRequest): Promise<LicenseOwner> {
        const span = this.tracer.startSpan("POST /LicenseOwners", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/LicenseOwners";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processCreate(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processCreate(response: Response): Promise<LicenseOwner> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = LicenseOwner.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseOwner>(null as any);
    }

    async getById(id: number): Promise<LicenseOwner> {
        const span = this.tracer.startSpan("GET /LicenseOwners/{id}", {
            attributes: {
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/LicenseOwners/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetById(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetById(response: Response): Promise<LicenseOwner> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseOwner.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseOwner>(null as any);
    }

    async update(id: number, request: UpdateLicenseOwnerRequest): Promise<LicenseOwner> {
        const span = this.tracer.startSpan("PUT /LicenseOwners/{id}", {
            attributes: {
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/LicenseOwners/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processUpdate(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processUpdate(response: Response): Promise<LicenseOwner> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseOwner.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseOwner>(null as any);
    }

    async delete(id: number): Promise<FileResponse> {
        const span = this.tracer.startSpan("DELETE /LicenseOwners/{id}", {
            attributes: {
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/LicenseOwners/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

@inject(String, HttpClient)
export class LicensesClient extends PolicyClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("LicensesClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5910", baseUrl);
    }

    async getAll(): Promise<License[]> {
        const span = this.tracer.startSpan("GET /Licenses", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Licenses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetAll(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetAll(response: Response): Promise<License[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(License.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<License[]>(null as any);
    }

    async post(request: License): Promise<License> {
        const span = this.tracer.startSpan("POST /Licenses", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Licenses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<License> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = License.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<License>(null as any);
    }

    async put(request: License): Promise<License> {
        const span = this.tracer.startSpan("PUT /Licenses", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Licenses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPut(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPut(response: Response): Promise<License> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = License.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<License>(null as any);
    }

    async delete(id: number | undefined): Promise<void> {
        const span = this.tracer.startSpan("DELETE /Licenses", {
            attributes: {
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Licenses?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async get(id: number): Promise<License> {
        const span = this.tracer.startSpan("GET /Licenses/{id}", {
            attributes: {
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Licenses/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<License> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = License.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<License>(null as any);
    }
}

@inject(String, HttpClient)
export class ModulesClient extends PolicyClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("ModulesClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5910", baseUrl);
    }

    async getAll(): Promise<Module[]> {
        const span = this.tracer.startSpan("GET /Modules", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Modules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetAll(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetAll(response: Response): Promise<Module[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Module.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Module[]>(null as any);
    }

    async post(request: Module): Promise<Module> {
        const span = this.tracer.startSpan("POST /Modules", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Modules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<Module> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Module.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Module>(null as any);
    }

    async put(request: Module): Promise<Module> {
        const span = this.tracer.startSpan("PUT /Modules", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Modules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPut(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPut(response: Response): Promise<Module> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Module.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Module>(null as any);
    }

    async delete(id: number | undefined): Promise<void> {
        const span = this.tracer.startSpan("DELETE /Modules", {
            attributes: {
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Modules?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async get(id: number): Promise<Module> {
        const span = this.tracer.startSpan("GET /Modules/{id}", {
            attributes: {
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Modules/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<Module> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Module.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Module>(null as any);
    }
}

@inject(String, HttpClient)
export class PackagesClient extends PolicyClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("PackagesClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5910", baseUrl);
    }

    async get(): Promise<Package[]> {
        const span = this.tracer.startSpan("GET /Packages", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Packages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<Package[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Package.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Package[]>(null as any);
    }

    async create(request: CreatePackageRequest): Promise<Package> {
        const span = this.tracer.startSpan("POST /Packages", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Packages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processCreate(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processCreate(response: Response): Promise<Package> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Package.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Package>(null as any);
    }

    async getById(id: number): Promise<Package> {
        const span = this.tracer.startSpan("GET /Packages/{id}", {
            attributes: {
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Packages/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetById(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetById(response: Response): Promise<Package> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Package.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Package>(null as any);
    }

    async update(id: number, request: UpdatePackageRequest): Promise<Package> {
        const span = this.tracer.startSpan("PUT /Packages/{id}", {
            attributes: {
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Packages/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processUpdate(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processUpdate(response: Response): Promise<Package> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Package.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Package>(null as any);
    }

    async delete(id: number): Promise<FileResponse> {
        const span = this.tracer.startSpan("DELETE /Packages/{id}", {
            attributes: {
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Packages/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

@inject(String, HttpClient)
export class PartnersClient extends PolicyClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("PartnersClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5910", baseUrl);
    }

    async getAll(): Promise<Partner[]> {
        const span = this.tracer.startSpan("GET /Partners", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Partners";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetAll(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetAll(response: Response): Promise<Partner[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Partner.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Partner[]>(null as any);
    }

    async create(partner: Partner): Promise<Partner> {
        const span = this.tracer.startSpan("POST /Partners", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Partners";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(partner);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processCreate(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processCreate(response: Response): Promise<Partner> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Partner.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Partner>(null as any);
    }

    async get(id: number): Promise<Partner> {
        const span = this.tracer.startSpan("GET /Partners/{id}", {
            attributes: {
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Partners/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<Partner> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Partner.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Partner>(null as any);
    }

    async update(id: number, partner: Partner): Promise<Partner> {
        const span = this.tracer.startSpan("PUT /Partners/{id}", {
            attributes: {
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Partners/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(partner);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processUpdate(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processUpdate(response: Response): Promise<Partner> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Partner.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Partner>(null as any);
    }

    async delete(id: number): Promise<void> {
        const span = this.tracer.startSpan("DELETE /Partners/{id}", {
            attributes: {
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Partners/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

@inject(String, HttpClient)
export class PathsClient extends PolicyClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("PathsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5910", baseUrl);
    }

    async get(): Promise<Path[]> {
        const span = this.tracer.startSpan("GET /Paths", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Paths";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<Path[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Path.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Path[]>(null as any);
    }

    async post(request: Path): Promise<Path> {
        const span = this.tracer.startSpan("POST /Paths", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Paths";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<Path> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Path.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Path>(null as any);
    }

    async put(request: Path): Promise<Path> {
        const span = this.tracer.startSpan("PUT /Paths", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Paths";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPut(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPut(response: Response): Promise<Path> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Path.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Path>(null as any);
    }

    async delete(id: number | undefined): Promise<void> {
        const span = this.tracer.startSpan("DELETE /Paths", {
            attributes: {
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Paths?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

@inject(String, HttpClient)
export class PermissionsClient extends PolicyClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("PermissionsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5910", baseUrl);
    }

    async get(): Promise<Permission[]> {
        const span = this.tracer.startSpan("GET /Permissions", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<Permission[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Permission.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Permission[]>(null as any);
    }

    async post(request: Permission): Promise<Permission> {
        const span = this.tracer.startSpan("POST /Permissions", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Permissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<Permission> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Permission.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Permission>(null as any);
    }

    async put(request: Permission): Promise<Permission> {
        const span = this.tracer.startSpan("PUT /Permissions", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Permissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPut(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPut(response: Response): Promise<Permission> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Permission.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Permission>(null as any);
    }

    async delete(id: number): Promise<void> {
        const span = this.tracer.startSpan("DELETE /Permissions/{id}", {
            attributes: {
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Permissions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

@inject(String, HttpClient)
export class RolePermissionsClient extends PolicyClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("RolePermissionsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5910", baseUrl);
    }

    async get(roleId: number | undefined): Promise<RolePermission[]> {
        const span = this.tracer.startSpan("GET /RolePermissions", {
            attributes: {
                "roleId": roleId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/RolePermissions?";
        if (roleId === null)
            throw new globalThis.Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<RolePermission[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RolePermission.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RolePermission[]>(null as any);
    }

    async post(request: RolePermission): Promise<RolePermission> {
        const span = this.tracer.startSpan("POST /RolePermissions", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/RolePermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<RolePermission> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RolePermission.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RolePermission>(null as any);
    }

    async delete(id: number): Promise<void> {
        const span = this.tracer.startSpan("DELETE /RolePermissions/{id}", {
            attributes: {
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/RolePermissions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

@inject(String, HttpClient)
export class RolesClient extends PolicyClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("RolesClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5910", baseUrl);
    }

    async get(): Promise<Role[]> {
        const span = this.tracer.startSpan("GET /Roles", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<Role[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Role.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Role[]>(null as any);
    }
}

@inject(String, HttpClient)
export class UserCustomerRolesClient extends PolicyClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("UserCustomerRolesClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5910", baseUrl);
    }

    async get(companyIdentityId: number): Promise<UserCustomerRole[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/UserCustomerRoles", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/UserCustomerRoles";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<UserCustomerRole[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserCustomerRole.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserCustomerRole[]>(null as any);
    }

    async post(companyIdentityId: number, request: UserCustomerRole): Promise<UserCustomerRole> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/UserCustomerRoles", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/UserCustomerRoles";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<UserCustomerRole> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCustomerRole.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserCustomerRole>(null as any);
    }

    async delete(companyIdentityId: number, id: number): Promise<void> {
        const span = this.tracer.startSpan("DELETE /companies/{companyIdentityId}/UserCustomerRoles/{id}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/UserCustomerRoles/{id}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

@inject(String, HttpClient)
export class UsersClient extends PolicyClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("UsersClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5910", baseUrl);
    }

    async lookup(): Promise<UserLookupViewModel[]> {
        const span = this.tracer.startSpan("GET /Users/Lookup", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Users/Lookup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processLookup(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processLookup(response: Response): Promise<UserLookupViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserLookupViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserLookupViewModel[]>(null as any);
    }

    async get(id: number): Promise<User> {
        const span = this.tracer.startSpan("GET /Users/{id}", {
            attributes: {
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Users/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(null as any);
    }

    async getAll(): Promise<User[]> {
        const span = this.tracer.startSpan("GET /Users", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetAll(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetAll(response: Response): Promise<User[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(User.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User[]>(null as any);
    }

    async post(request: User): Promise<User> {
        const span = this.tracer.startSpan("POST /Users", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(null as any);
    }

    async patch(request: User): Promise<User> {
        const span = this.tracer.startSpan("PATCH /Users", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPatch(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPatch(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(null as any);
    }

    async me(): Promise<OpaGetUserResultUser> {
        const span = this.tracer.startSpan("GET /Users/Me", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Users/Me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processMe(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processMe(response: Response): Promise<OpaGetUserResultUser> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OpaGetUserResultUser.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OpaGetUserResultUser>(null as any);
    }
}

export class CustomerViewModel implements ICustomerViewModel {
    id?: number;
    uuid?: string;
    currentState?: string;
    customerName?: string | undefined;
    hasAcceptedLicenseAgreement?: boolean;
    licenses?: LicenseViewModel[];
    glApiUrl?: string | undefined;
    glTestApiUrl?: string | undefined;
    glAccountsTemplate?: GlAccountsTemplate;
    pogoClientId?: string | undefined;
    pogoClientKey?: string | undefined;
    vatNumber?: string | undefined;
    companyEmail?: string | undefined;
    voucherReceivingEmail?: string | undefined;
    externalGlSystem?: ExternalGlSystemViewModel | undefined;
    lockDate?: string | undefined;
    hasInvitedUsers?: boolean;
    useAiTranslatorOnPdf?: boolean;
    partnerId?: number | undefined;
    licenseOwnerId?: number | undefined;
    deleteDate?: string | undefined;
    created?: string;
    createdByEmail?: string | undefined;
    status?: CustomerStatus;
    instrumentTypes?: InstrumentType[] | undefined;
    customAttributes?: { [key: string]: string; } | undefined;
    internalNotes?: string | undefined;
    integrationSuspended?: boolean;
    users?: string | undefined;
    useAverageCostPrice?: boolean;
    usePortfolio?: boolean;
    useVisma?: boolean;
    defaultPortfolioCategoryId?: number | undefined;
    restQuantityThreshold?: number;
    restCostpriceThreshold?: number;
    defaultChartTheme?: string | undefined;
    defaultPhoneDashboard?: string | undefined;
    defaultTabletDashboard?: string | undefined;
    defaultDesktopDashboard?: string | undefined;
    closePeriodDate?: string | undefined;
    corporationId?: string | undefined;
    transactionCountThisYear?: number;
    transactionCountThisMonth?: number;

    constructor(data?: ICustomerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uuid = _data["uuid"];
            this.currentState = _data["currentState"];
            this.customerName = _data["customerName"];
            this.hasAcceptedLicenseAgreement = _data["hasAcceptedLicenseAgreement"];
            if (Array.isArray(_data["licenses"])) {
                this.licenses = [] as any;
                for (let item of _data["licenses"])
                    this.licenses!.push(LicenseViewModel.fromJS(item));
            }
            this.glApiUrl = _data["glApiUrl"];
            this.glTestApiUrl = _data["glTestApiUrl"];
            this.glAccountsTemplate = _data["glAccountsTemplate"];
            this.pogoClientId = _data["pogoClientId"];
            this.pogoClientKey = _data["pogoClientKey"];
            this.vatNumber = _data["vatNumber"];
            this.companyEmail = _data["companyEmail"];
            this.voucherReceivingEmail = _data["voucherReceivingEmail"];
            this.externalGlSystem = _data["externalGlSystem"] ? ExternalGlSystemViewModel.fromJS(_data["externalGlSystem"]) : undefined as any;
            this.lockDate = _data["lockDate"];
            this.hasInvitedUsers = _data["hasInvitedUsers"];
            this.useAiTranslatorOnPdf = _data["useAiTranslatorOnPdf"];
            this.partnerId = _data["partnerId"];
            this.licenseOwnerId = _data["licenseOwnerId"];
            this.deleteDate = _data["deleteDate"];
            this.created = _data["created"];
            this.createdByEmail = _data["createdByEmail"];
            this.status = _data["status"];
            if (Array.isArray(_data["instrumentTypes"])) {
                this.instrumentTypes = [] as any;
                for (let item of _data["instrumentTypes"])
                    this.instrumentTypes!.push(item);
            }
            if (_data["customAttributes"]) {
                this.customAttributes = {} as any;
                for (let key in _data["customAttributes"]) {
                    if (_data["customAttributes"].hasOwnProperty(key))
                        (this.customAttributes as any)![key] = _data["customAttributes"][key];
                }
            }
            this.internalNotes = _data["internalNotes"];
            this.integrationSuspended = _data["integrationSuspended"];
            this.users = _data["users"];
            this.useAverageCostPrice = _data["useAverageCostPrice"];
            this.usePortfolio = _data["usePortfolio"];
            this.useVisma = _data["useVisma"];
            this.defaultPortfolioCategoryId = _data["defaultPortfolioCategoryId"];
            this.restQuantityThreshold = _data["restQuantityThreshold"];
            this.restCostpriceThreshold = _data["restCostpriceThreshold"];
            this.defaultChartTheme = _data["defaultChartTheme"];
            this.defaultPhoneDashboard = _data["defaultPhoneDashboard"];
            this.defaultTabletDashboard = _data["defaultTabletDashboard"];
            this.defaultDesktopDashboard = _data["defaultDesktopDashboard"];
            this.closePeriodDate = _data["closePeriodDate"];
            this.corporationId = _data["corporationId"];
            this.transactionCountThisYear = _data["transactionCountThisYear"];
            this.transactionCountThisMonth = _data["transactionCountThisMonth"];
        }
    }

    static fromJS(data: any): CustomerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uuid"] = this.uuid;
        data["currentState"] = this.currentState;
        data["customerName"] = this.customerName;
        data["hasAcceptedLicenseAgreement"] = this.hasAcceptedLicenseAgreement;
        if (Array.isArray(this.licenses)) {
            data["licenses"] = [];
            for (let item of this.licenses)
                data["licenses"].push(item ? item.toJSON() : undefined as any);
        }
        data["glApiUrl"] = this.glApiUrl;
        data["glTestApiUrl"] = this.glTestApiUrl;
        data["glAccountsTemplate"] = this.glAccountsTemplate;
        data["pogoClientId"] = this.pogoClientId;
        data["pogoClientKey"] = this.pogoClientKey;
        data["vatNumber"] = this.vatNumber;
        data["companyEmail"] = this.companyEmail;
        data["voucherReceivingEmail"] = this.voucherReceivingEmail;
        data["externalGlSystem"] = this.externalGlSystem ? this.externalGlSystem.toJSON() : undefined as any;
        data["lockDate"] = this.lockDate;
        data["hasInvitedUsers"] = this.hasInvitedUsers;
        data["useAiTranslatorOnPdf"] = this.useAiTranslatorOnPdf;
        data["partnerId"] = this.partnerId;
        data["licenseOwnerId"] = this.licenseOwnerId;
        data["deleteDate"] = this.deleteDate;
        data["created"] = this.created;
        data["createdByEmail"] = this.createdByEmail;
        data["status"] = this.status;
        if (Array.isArray(this.instrumentTypes)) {
            data["instrumentTypes"] = [];
            for (let item of this.instrumentTypes)
                data["instrumentTypes"].push(item);
        }
        if (this.customAttributes) {
            data["customAttributes"] = {};
            for (let key in this.customAttributes) {
                if (this.customAttributes.hasOwnProperty(key))
                    (data["customAttributes"] as any)[key] = (this.customAttributes as any)[key];
            }
        }
        data["internalNotes"] = this.internalNotes;
        data["integrationSuspended"] = this.integrationSuspended;
        data["users"] = this.users;
        data["useAverageCostPrice"] = this.useAverageCostPrice;
        data["usePortfolio"] = this.usePortfolio;
        data["useVisma"] = this.useVisma;
        data["defaultPortfolioCategoryId"] = this.defaultPortfolioCategoryId;
        data["restQuantityThreshold"] = this.restQuantityThreshold;
        data["restCostpriceThreshold"] = this.restCostpriceThreshold;
        data["defaultChartTheme"] = this.defaultChartTheme;
        data["defaultPhoneDashboard"] = this.defaultPhoneDashboard;
        data["defaultTabletDashboard"] = this.defaultTabletDashboard;
        data["defaultDesktopDashboard"] = this.defaultDesktopDashboard;
        data["closePeriodDate"] = this.closePeriodDate;
        data["corporationId"] = this.corporationId;
        data["transactionCountThisYear"] = this.transactionCountThisYear;
        data["transactionCountThisMonth"] = this.transactionCountThisMonth;
        return data;
    }
}

export interface ICustomerViewModel {
    id?: number;
    uuid?: string;
    currentState?: string;
    customerName?: string | undefined;
    hasAcceptedLicenseAgreement?: boolean;
    licenses?: LicenseViewModel[];
    glApiUrl?: string | undefined;
    glTestApiUrl?: string | undefined;
    glAccountsTemplate?: GlAccountsTemplate;
    pogoClientId?: string | undefined;
    pogoClientKey?: string | undefined;
    vatNumber?: string | undefined;
    companyEmail?: string | undefined;
    voucherReceivingEmail?: string | undefined;
    externalGlSystem?: ExternalGlSystemViewModel | undefined;
    lockDate?: string | undefined;
    hasInvitedUsers?: boolean;
    useAiTranslatorOnPdf?: boolean;
    partnerId?: number | undefined;
    licenseOwnerId?: number | undefined;
    deleteDate?: string | undefined;
    created?: string;
    createdByEmail?: string | undefined;
    status?: CustomerStatus;
    instrumentTypes?: InstrumentType[] | undefined;
    customAttributes?: { [key: string]: string; } | undefined;
    internalNotes?: string | undefined;
    integrationSuspended?: boolean;
    users?: string | undefined;
    useAverageCostPrice?: boolean;
    usePortfolio?: boolean;
    useVisma?: boolean;
    defaultPortfolioCategoryId?: number | undefined;
    restQuantityThreshold?: number;
    restCostpriceThreshold?: number;
    defaultChartTheme?: string | undefined;
    defaultPhoneDashboard?: string | undefined;
    defaultTabletDashboard?: string | undefined;
    defaultDesktopDashboard?: string | undefined;
    closePeriodDate?: string | undefined;
    corporationId?: string | undefined;
    transactionCountThisYear?: number;
    transactionCountThisMonth?: number;
}

export class LicenseViewModel implements ILicenseViewModel {
    id?: number | undefined;
    name?: string | undefined;
    startDate?: string;
    modules?: ModuleViewModel[] | undefined;
    sellPrice?: number;
    paymentInterval?: PaymentIntervalType;
    lastPayment?: string | undefined;
    payments?: PaymentViewModel[] | undefined;

    constructor(data?: ILicenseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.startDate = _data["startDate"];
            if (Array.isArray(_data["modules"])) {
                this.modules = [] as any;
                for (let item of _data["modules"])
                    this.modules!.push(ModuleViewModel.fromJS(item));
            }
            this.sellPrice = _data["sellPrice"];
            this.paymentInterval = _data["paymentInterval"];
            this.lastPayment = _data["lastPayment"];
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments!.push(PaymentViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LicenseViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["startDate"] = this.startDate;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item ? item.toJSON() : undefined as any);
        }
        data["sellPrice"] = this.sellPrice;
        data["paymentInterval"] = this.paymentInterval;
        data["lastPayment"] = this.lastPayment;
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILicenseViewModel {
    id?: number | undefined;
    name?: string | undefined;
    startDate?: string;
    modules?: ModuleViewModel[] | undefined;
    sellPrice?: number;
    paymentInterval?: PaymentIntervalType;
    lastPayment?: string | undefined;
    payments?: PaymentViewModel[] | undefined;
}

export class ModuleViewModel implements IModuleViewModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    licenses?: LicenseViewModel[] | undefined;
    permissions?: Permission[] | undefined;
    sellPrice?: number;

    constructor(data?: IModuleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["licenses"])) {
                this.licenses = [] as any;
                for (let item of _data["licenses"])
                    this.licenses!.push(LicenseViewModel.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(Permission.fromJS(item));
            }
            this.sellPrice = _data["sellPrice"];
        }
    }

    static fromJS(data: any): ModuleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.licenses)) {
            data["licenses"] = [];
            for (let item of this.licenses)
                data["licenses"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        data["sellPrice"] = this.sellPrice;
        return data;
    }
}

export interface IModuleViewModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    licenses?: LicenseViewModel[] | undefined;
    permissions?: Permission[] | undefined;
    sellPrice?: number;
}

export class Permission implements IPermission {
    id?: number;
    name!: string;
    entity?: string | undefined;
    permissionPaths?: PermissionPath[] | undefined;
    rolePermissions?: RolePermission[] | undefined;

    constructor(data?: IPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.entity = _data["entity"];
            if (Array.isArray(_data["permissionPaths"])) {
                this.permissionPaths = [] as any;
                for (let item of _data["permissionPaths"])
                    this.permissionPaths!.push(PermissionPath.fromJS(item));
            }
            if (Array.isArray(_data["rolePermissions"])) {
                this.rolePermissions = [] as any;
                for (let item of _data["rolePermissions"])
                    this.rolePermissions!.push(RolePermission.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Permission {
        data = typeof data === 'object' ? data : {};
        let result = new Permission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["entity"] = this.entity;
        if (Array.isArray(this.permissionPaths)) {
            data["permissionPaths"] = [];
            for (let item of this.permissionPaths)
                data["permissionPaths"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rolePermissions)) {
            data["rolePermissions"] = [];
            for (let item of this.rolePermissions)
                data["rolePermissions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPermission {
    id?: number;
    name: string;
    entity?: string | undefined;
    permissionPaths?: PermissionPath[] | undefined;
    rolePermissions?: RolePermission[] | undefined;
}

export class PermissionPath implements IPermissionPath {
    id?: number;
    permissionId?: number;
    permission?: Permission;
    pathId?: number;
    path?: Path;
    method?: string;

    constructor(data?: IPermissionPath) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.permissionId = _data["permissionId"];
            this.permission = _data["permission"] ? Permission.fromJS(_data["permission"]) : undefined as any;
            this.pathId = _data["pathId"];
            this.path = _data["path"] ? Path.fromJS(_data["path"]) : undefined as any;
            this.method = _data["method"];
        }
    }

    static fromJS(data: any): PermissionPath {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionPath();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["permissionId"] = this.permissionId;
        data["permission"] = this.permission ? this.permission.toJSON() : undefined as any;
        data["pathId"] = this.pathId;
        data["path"] = this.path ? this.path.toJSON() : undefined as any;
        data["method"] = this.method;
        return data;
    }
}

export interface IPermissionPath {
    id?: number;
    permissionId?: number;
    permission?: Permission;
    pathId?: number;
    path?: Path;
    method?: string;
}

export class Path implements IPath {
    id?: number;
    name?: string | undefined;
    servicePath?: string;
    url!: string;
    key?: string;
    public?: boolean;
    controllerName?: string;
    actions?: string;
    permissionPaths?: PermissionPath[] | undefined;

    constructor(data?: IPath) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.servicePath = _data["servicePath"];
            this.url = _data["url"];
            this.key = _data["key"];
            this.public = _data["public"];
            this.controllerName = _data["controllerName"];
            this.actions = _data["actions"];
            if (Array.isArray(_data["permissionPaths"])) {
                this.permissionPaths = [] as any;
                for (let item of _data["permissionPaths"])
                    this.permissionPaths!.push(PermissionPath.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Path {
        data = typeof data === 'object' ? data : {};
        let result = new Path();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["servicePath"] = this.servicePath;
        data["url"] = this.url;
        data["key"] = this.key;
        data["public"] = this.public;
        data["controllerName"] = this.controllerName;
        data["actions"] = this.actions;
        if (Array.isArray(this.permissionPaths)) {
            data["permissionPaths"] = [];
            for (let item of this.permissionPaths)
                data["permissionPaths"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPath {
    id?: number;
    name?: string | undefined;
    servicePath?: string;
    url: string;
    key?: string;
    public?: boolean;
    controllerName?: string;
    actions?: string;
    permissionPaths?: PermissionPath[] | undefined;
}

export class RolePermission implements IRolePermission {
    id?: number;
    roleId?: number;
    role?: Role;
    permissionId?: number;
    permission?: Permission;

    constructor(data?: IRolePermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roleId = _data["roleId"];
            this.role = _data["role"] ? Role.fromJS(_data["role"]) : undefined as any;
            this.permissionId = _data["permissionId"];
            this.permission = _data["permission"] ? Permission.fromJS(_data["permission"]) : undefined as any;
        }
    }

    static fromJS(data: any): RolePermission {
        data = typeof data === 'object' ? data : {};
        let result = new RolePermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roleId"] = this.roleId;
        data["role"] = this.role ? this.role.toJSON() : undefined as any;
        data["permissionId"] = this.permissionId;
        data["permission"] = this.permission ? this.permission.toJSON() : undefined as any;
        return data;
    }
}

export interface IRolePermission {
    id?: number;
    roleId?: number;
    role?: Role;
    permissionId?: number;
    permission?: Permission;
}

export class Role implements IRole {
    id?: number;
    name!: string;
    displayName?: string | undefined;
    userCustomerRoles?: UserCustomerRole[] | undefined;
    userRoles?: UserRole[] | undefined;
    rolePermissions?: RolePermission[] | undefined;

    constructor(data?: IRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["userCustomerRoles"])) {
                this.userCustomerRoles = [] as any;
                for (let item of _data["userCustomerRoles"])
                    this.userCustomerRoles!.push(UserCustomerRole.fromJS(item));
            }
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data["rolePermissions"])) {
                this.rolePermissions = [] as any;
                for (let item of _data["rolePermissions"])
                    this.rolePermissions!.push(RolePermission.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.userCustomerRoles)) {
            data["userCustomerRoles"] = [];
            for (let item of this.userCustomerRoles)
                data["userCustomerRoles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rolePermissions)) {
            data["rolePermissions"] = [];
            for (let item of this.rolePermissions)
                data["rolePermissions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRole {
    id?: number;
    name: string;
    displayName?: string | undefined;
    userCustomerRoles?: UserCustomerRole[] | undefined;
    userRoles?: UserRole[] | undefined;
    rolePermissions?: RolePermission[] | undefined;
}

export class UserCustomerRole implements IUserCustomerRole {
    id?: number;
    userId?: number;
    user?: User | undefined;
    customerId?: number;
    customerUuid?: string;
    customerState?: CustomerState | undefined;
    roleId?: number;
    role?: Role | undefined;

    constructor(data?: IUserCustomerRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined as any;
            this.customerId = _data["customerId"];
            this.customerUuid = _data["customerUuid"];
            this.customerState = _data["customerState"] ? CustomerState.fromJS(_data["customerState"]) : undefined as any;
            this.roleId = _data["roleId"];
            this.role = _data["role"] ? Role.fromJS(_data["role"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserCustomerRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserCustomerRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["customerId"] = this.customerId;
        data["customerUuid"] = this.customerUuid;
        data["customerState"] = this.customerState ? this.customerState.toJSON() : undefined as any;
        data["roleId"] = this.roleId;
        data["role"] = this.role ? this.role.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserCustomerRole {
    id?: number;
    userId?: number;
    user?: User | undefined;
    customerId?: number;
    customerUuid?: string;
    customerState?: CustomerState | undefined;
    roleId?: number;
    role?: Role | undefined;
}

export class User implements IUser {
    id?: number;
    firstName?: string;
    lastname?: string;
    phone?: string;
    email?: string;
    disabled?: boolean;
    userCustomerRoles?: UserCustomerRole[] | undefined;
    userCorporationRoles?: UserCorporationRole[] | undefined;
    userRoles?: UserRole[] | undefined;
    userAcceptedEulas?: UserAcceptedEula[] | undefined;
    correlationId?: string;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastname = _data["lastname"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.disabled = _data["disabled"];
            if (Array.isArray(_data["userCustomerRoles"])) {
                this.userCustomerRoles = [] as any;
                for (let item of _data["userCustomerRoles"])
                    this.userCustomerRoles!.push(UserCustomerRole.fromJS(item));
            }
            if (Array.isArray(_data["userCorporationRoles"])) {
                this.userCorporationRoles = [] as any;
                for (let item of _data["userCorporationRoles"])
                    this.userCorporationRoles!.push(UserCorporationRole.fromJS(item));
            }
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data["userAcceptedEulas"])) {
                this.userAcceptedEulas = [] as any;
                for (let item of _data["userAcceptedEulas"])
                    this.userAcceptedEulas!.push(UserAcceptedEula.fromJS(item));
            }
            this.correlationId = _data["correlationId"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastname"] = this.lastname;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["disabled"] = this.disabled;
        if (Array.isArray(this.userCustomerRoles)) {
            data["userCustomerRoles"] = [];
            for (let item of this.userCustomerRoles)
                data["userCustomerRoles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userCorporationRoles)) {
            data["userCorporationRoles"] = [];
            for (let item of this.userCorporationRoles)
                data["userCorporationRoles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userAcceptedEulas)) {
            data["userAcceptedEulas"] = [];
            for (let item of this.userAcceptedEulas)
                data["userAcceptedEulas"].push(item ? item.toJSON() : undefined as any);
        }
        data["correlationId"] = this.correlationId;
        return data;
    }
}

export interface IUser {
    id?: number;
    firstName?: string;
    lastname?: string;
    phone?: string;
    email?: string;
    disabled?: boolean;
    userCustomerRoles?: UserCustomerRole[] | undefined;
    userCorporationRoles?: UserCorporationRole[] | undefined;
    userRoles?: UserRole[] | undefined;
    userAcceptedEulas?: UserAcceptedEula[] | undefined;
    correlationId?: string;
}

export class UserCorporationRole implements IUserCorporationRole {
    userId?: number;
    user?: User;
    roleId?: number;
    role?: Role;
    corporationId?: string;
    corporation?: Corporation;

    constructor(data?: IUserCorporationRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined as any;
            this.roleId = _data["roleId"];
            this.role = _data["role"] ? Role.fromJS(_data["role"]) : undefined as any;
            this.corporationId = _data["corporationId"];
            this.corporation = _data["corporation"] ? Corporation.fromJS(_data["corporation"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserCorporationRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserCorporationRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["roleId"] = this.roleId;
        data["role"] = this.role ? this.role.toJSON() : undefined as any;
        data["corporationId"] = this.corporationId;
        data["corporation"] = this.corporation ? this.corporation.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserCorporationRole {
    userId?: number;
    user?: User;
    roleId?: number;
    role?: Role;
    corporationId?: string;
    corporation?: Corporation;
}

export class Corporation implements ICorporation {
    id?: string;
    corporationName?: string | undefined;
    customers?: CustomerState[] | undefined;
    userCorporationRoles?: UserCorporationRole[] | undefined;

    constructor(data?: ICorporation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.corporationName = _data["corporationName"];
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(CustomerState.fromJS(item));
            }
            if (Array.isArray(_data["userCorporationRoles"])) {
                this.userCorporationRoles = [] as any;
                for (let item of _data["userCorporationRoles"])
                    this.userCorporationRoles!.push(UserCorporationRole.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Corporation {
        data = typeof data === 'object' ? data : {};
        let result = new Corporation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["corporationName"] = this.corporationName;
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userCorporationRoles)) {
            data["userCorporationRoles"] = [];
            for (let item of this.userCorporationRoles)
                data["userCorporationRoles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICorporation {
    id?: string;
    corporationName?: string | undefined;
    customers?: CustomerState[] | undefined;
    userCorporationRoles?: UserCorporationRole[] | undefined;
}

export class CustomerState implements ICustomerState {
    correlationId?: string;
    id?: number;
    currentState?: CustomerStateMachineStatus;
    customerName?: string;
    pogoClientId?: string | undefined;
    createdByEmail?: string | undefined;
    pogoClientKey?: string | undefined;
    glApiUrl?: string | undefined;
    glTestApiUrl?: string | undefined;
    sessionToken?: string | undefined;
    vatNumber?: string | undefined;
    companyEmail?: string | undefined;
    voucherReceivingEmail?: string | undefined;
    externalGlSystem?: ExternalGlSystem | undefined;
    externalGlSystemId?: number | undefined;
    lockDate?: string | undefined;
    hasSetupIntegration?: boolean;
    hasCreatedAccounts?: boolean;
    hasInvitedUsers?: boolean;
    useAiTranslatorOnPdf?: boolean;
    useAverageCostPrice?: boolean;
    usePortfolio?: boolean;
    useVisma?: boolean;
    defaultPortfolioCategoryId?: number | undefined;
    restQuantityThreshold?: number;
    restCostpriceThreshold?: number;
    defaultChartTheme?: string | undefined;
    defaultPhoneDashboard?: string | undefined;
    defaultTabletDashboard?: string | undefined;
    defaultDesktopDashboard?: string | undefined;
    closePeriodDate?: string | undefined;
    partnerId?: number | undefined;
    partner?: Partner | undefined;
    licenseOwnerId?: number | undefined;
    licenseOwner?: LicenseOwner | undefined;
    corporationId?: string | undefined;
    corporation?: Corporation | undefined;
    created?: string;
    creatingDefaultGlAccountsFaultReason?: string | undefined;
    createdById?: number | undefined;
    createdBy?: User | undefined;
    status?: CustomerStatus;
    deleteDate?: string | undefined;
    finalDeleteWarningDate?: string | undefined;
    userCustomerRoles?: UserCustomerRole[] | undefined;
    licenses?: License[] | undefined;
    instrumentTypes?: InstrumentType[] | undefined;
    customAttributes?: { [key: string]: string; } | undefined;
    internalNotes?: string | undefined;
    integrationSuspended?: boolean;
    createDefaultGlAccountsRequestId?: string | undefined;
    createOrUpdateTransactionCustomerRequestId?: string | undefined;
    createOrUpdateTransactionCustomerFaultReason?: string | undefined;
    createOrUpdateReportingCustomerRequestId?: string | undefined;
    createOrUpdateReportingCustomerFaultReason?: string | undefined;
    deleteTransactionCustomerRequestId?: string | undefined;
    deleteTransactionCustomerFaultReason?: string | undefined;
    deleteReportingCustomerRequestId?: string | undefined;
    deleteReportingCustomerFaultReason?: string | undefined;
    deleteInboxCustomerRequestId?: string | undefined;
    deleteInboxCustomerFaultReason?: string | undefined;
    deletionTracking?: number;
    clearIntegrationTracking?: number;
    version?: number;
    clearTransactionCustomerIntegrationRequestId?: string | undefined;
    clearTransactionCustomerIntegrationFaultReason?: string | undefined;
    purgeReportingCustomerGlDataRequestId?: string | undefined;
    purgeReportingCustomerGlDataFaultReason?: string | undefined;
    debouncedFetchCustomerGlTransactionsTokenId?: string | undefined;
    validateClearIntegrationRequestId?: string | undefined;
    clearIntegrationCutoffDate?: string | undefined;
    glAccountsTemplate?: GlAccountsTemplate;

    constructor(data?: ICustomerState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.correlationId = _data["correlationId"];
            this.id = _data["id"];
            this.currentState = _data["currentState"];
            this.customerName = _data["customerName"];
            this.pogoClientId = _data["pogoClientId"];
            this.createdByEmail = _data["createdByEmail"];
            this.pogoClientKey = _data["pogoClientKey"];
            this.glApiUrl = _data["glApiUrl"];
            this.glTestApiUrl = _data["glTestApiUrl"];
            this.sessionToken = _data["sessionToken"];
            this.vatNumber = _data["vatNumber"];
            this.companyEmail = _data["companyEmail"];
            this.voucherReceivingEmail = _data["voucherReceivingEmail"];
            this.externalGlSystem = _data["externalGlSystem"] ? ExternalGlSystem.fromJS(_data["externalGlSystem"]) : undefined as any;
            this.externalGlSystemId = _data["externalGlSystemId"];
            this.lockDate = _data["lockDate"];
            this.hasSetupIntegration = _data["hasSetupIntegration"];
            this.hasCreatedAccounts = _data["hasCreatedAccounts"];
            this.hasInvitedUsers = _data["hasInvitedUsers"];
            this.useAiTranslatorOnPdf = _data["useAiTranslatorOnPdf"];
            this.useAverageCostPrice = _data["useAverageCostPrice"];
            this.usePortfolio = _data["usePortfolio"];
            this.useVisma = _data["useVisma"];
            this.defaultPortfolioCategoryId = _data["defaultPortfolioCategoryId"];
            this.restQuantityThreshold = _data["restQuantityThreshold"];
            this.restCostpriceThreshold = _data["restCostpriceThreshold"];
            this.defaultChartTheme = _data["defaultChartTheme"];
            this.defaultPhoneDashboard = _data["defaultPhoneDashboard"];
            this.defaultTabletDashboard = _data["defaultTabletDashboard"];
            this.defaultDesktopDashboard = _data["defaultDesktopDashboard"];
            this.closePeriodDate = _data["closePeriodDate"];
            this.partnerId = _data["partnerId"];
            this.partner = _data["partner"] ? Partner.fromJS(_data["partner"]) : undefined as any;
            this.licenseOwnerId = _data["licenseOwnerId"];
            this.licenseOwner = _data["licenseOwner"] ? LicenseOwner.fromJS(_data["licenseOwner"]) : undefined as any;
            this.corporationId = _data["corporationId"];
            this.corporation = _data["corporation"] ? Corporation.fromJS(_data["corporation"]) : undefined as any;
            this.created = _data["created"];
            this.creatingDefaultGlAccountsFaultReason = _data["creatingDefaultGlAccountsFaultReason"];
            this.createdById = _data["createdById"];
            this.createdBy = _data["createdBy"] ? User.fromJS(_data["createdBy"]) : undefined as any;
            this.status = _data["status"];
            this.deleteDate = _data["deleteDate"];
            this.finalDeleteWarningDate = _data["finalDeleteWarningDate"];
            if (Array.isArray(_data["userCustomerRoles"])) {
                this.userCustomerRoles = [] as any;
                for (let item of _data["userCustomerRoles"])
                    this.userCustomerRoles!.push(UserCustomerRole.fromJS(item));
            }
            if (Array.isArray(_data["licenses"])) {
                this.licenses = [] as any;
                for (let item of _data["licenses"])
                    this.licenses!.push(License.fromJS(item));
            }
            if (Array.isArray(_data["instrumentTypes"])) {
                this.instrumentTypes = [] as any;
                for (let item of _data["instrumentTypes"])
                    this.instrumentTypes!.push(item);
            }
            if (_data["customAttributes"]) {
                this.customAttributes = {} as any;
                for (let key in _data["customAttributes"]) {
                    if (_data["customAttributes"].hasOwnProperty(key))
                        (this.customAttributes as any)![key] = _data["customAttributes"][key];
                }
            }
            this.internalNotes = _data["internalNotes"];
            this.integrationSuspended = _data["integrationSuspended"];
            this.createDefaultGlAccountsRequestId = _data["createDefaultGlAccountsRequestId"];
            this.createOrUpdateTransactionCustomerRequestId = _data["createOrUpdateTransactionCustomerRequestId"];
            this.createOrUpdateTransactionCustomerFaultReason = _data["createOrUpdateTransactionCustomerFaultReason"];
            this.createOrUpdateReportingCustomerRequestId = _data["createOrUpdateReportingCustomerRequestId"];
            this.createOrUpdateReportingCustomerFaultReason = _data["createOrUpdateReportingCustomerFaultReason"];
            this.deleteTransactionCustomerRequestId = _data["deleteTransactionCustomerRequestId"];
            this.deleteTransactionCustomerFaultReason = _data["deleteTransactionCustomerFaultReason"];
            this.deleteReportingCustomerRequestId = _data["deleteReportingCustomerRequestId"];
            this.deleteReportingCustomerFaultReason = _data["deleteReportingCustomerFaultReason"];
            this.deleteInboxCustomerRequestId = _data["deleteInboxCustomerRequestId"];
            this.deleteInboxCustomerFaultReason = _data["deleteInboxCustomerFaultReason"];
            this.deletionTracking = _data["deletionTracking"];
            this.clearIntegrationTracking = _data["clearIntegrationTracking"];
            this.version = _data["version"];
            this.clearTransactionCustomerIntegrationRequestId = _data["clearTransactionCustomerIntegrationRequestId"];
            this.clearTransactionCustomerIntegrationFaultReason = _data["clearTransactionCustomerIntegrationFaultReason"];
            this.purgeReportingCustomerGlDataRequestId = _data["purgeReportingCustomerGlDataRequestId"];
            this.purgeReportingCustomerGlDataFaultReason = _data["purgeReportingCustomerGlDataFaultReason"];
            this.debouncedFetchCustomerGlTransactionsTokenId = _data["debouncedFetchCustomerGlTransactionsTokenId"];
            this.validateClearIntegrationRequestId = _data["validateClearIntegrationRequestId"];
            this.clearIntegrationCutoffDate = _data["clearIntegrationCutoffDate"];
            this.glAccountsTemplate = _data["glAccountsTemplate"];
        }
    }

    static fromJS(data: any): CustomerState {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["correlationId"] = this.correlationId;
        data["id"] = this.id;
        data["currentState"] = this.currentState;
        data["customerName"] = this.customerName;
        data["pogoClientId"] = this.pogoClientId;
        data["createdByEmail"] = this.createdByEmail;
        data["pogoClientKey"] = this.pogoClientKey;
        data["glApiUrl"] = this.glApiUrl;
        data["glTestApiUrl"] = this.glTestApiUrl;
        data["sessionToken"] = this.sessionToken;
        data["vatNumber"] = this.vatNumber;
        data["companyEmail"] = this.companyEmail;
        data["voucherReceivingEmail"] = this.voucherReceivingEmail;
        data["externalGlSystem"] = this.externalGlSystem ? this.externalGlSystem.toJSON() : undefined as any;
        data["externalGlSystemId"] = this.externalGlSystemId;
        data["lockDate"] = this.lockDate;
        data["hasSetupIntegration"] = this.hasSetupIntegration;
        data["hasCreatedAccounts"] = this.hasCreatedAccounts;
        data["hasInvitedUsers"] = this.hasInvitedUsers;
        data["useAiTranslatorOnPdf"] = this.useAiTranslatorOnPdf;
        data["useAverageCostPrice"] = this.useAverageCostPrice;
        data["usePortfolio"] = this.usePortfolio;
        data["useVisma"] = this.useVisma;
        data["defaultPortfolioCategoryId"] = this.defaultPortfolioCategoryId;
        data["restQuantityThreshold"] = this.restQuantityThreshold;
        data["restCostpriceThreshold"] = this.restCostpriceThreshold;
        data["defaultChartTheme"] = this.defaultChartTheme;
        data["defaultPhoneDashboard"] = this.defaultPhoneDashboard;
        data["defaultTabletDashboard"] = this.defaultTabletDashboard;
        data["defaultDesktopDashboard"] = this.defaultDesktopDashboard;
        data["closePeriodDate"] = this.closePeriodDate;
        data["partnerId"] = this.partnerId;
        data["partner"] = this.partner ? this.partner.toJSON() : undefined as any;
        data["licenseOwnerId"] = this.licenseOwnerId;
        data["licenseOwner"] = this.licenseOwner ? this.licenseOwner.toJSON() : undefined as any;
        data["corporationId"] = this.corporationId;
        data["corporation"] = this.corporation ? this.corporation.toJSON() : undefined as any;
        data["created"] = this.created;
        data["creatingDefaultGlAccountsFaultReason"] = this.creatingDefaultGlAccountsFaultReason;
        data["createdById"] = this.createdById;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : undefined as any;
        data["status"] = this.status;
        data["deleteDate"] = this.deleteDate;
        data["finalDeleteWarningDate"] = this.finalDeleteWarningDate;
        if (Array.isArray(this.userCustomerRoles)) {
            data["userCustomerRoles"] = [];
            for (let item of this.userCustomerRoles)
                data["userCustomerRoles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.licenses)) {
            data["licenses"] = [];
            for (let item of this.licenses)
                data["licenses"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.instrumentTypes)) {
            data["instrumentTypes"] = [];
            for (let item of this.instrumentTypes)
                data["instrumentTypes"].push(item);
        }
        if (this.customAttributes) {
            data["customAttributes"] = {};
            for (let key in this.customAttributes) {
                if (this.customAttributes.hasOwnProperty(key))
                    (data["customAttributes"] as any)[key] = (this.customAttributes as any)[key];
            }
        }
        data["internalNotes"] = this.internalNotes;
        data["integrationSuspended"] = this.integrationSuspended;
        data["createDefaultGlAccountsRequestId"] = this.createDefaultGlAccountsRequestId;
        data["createOrUpdateTransactionCustomerRequestId"] = this.createOrUpdateTransactionCustomerRequestId;
        data["createOrUpdateTransactionCustomerFaultReason"] = this.createOrUpdateTransactionCustomerFaultReason;
        data["createOrUpdateReportingCustomerRequestId"] = this.createOrUpdateReportingCustomerRequestId;
        data["createOrUpdateReportingCustomerFaultReason"] = this.createOrUpdateReportingCustomerFaultReason;
        data["deleteTransactionCustomerRequestId"] = this.deleteTransactionCustomerRequestId;
        data["deleteTransactionCustomerFaultReason"] = this.deleteTransactionCustomerFaultReason;
        data["deleteReportingCustomerRequestId"] = this.deleteReportingCustomerRequestId;
        data["deleteReportingCustomerFaultReason"] = this.deleteReportingCustomerFaultReason;
        data["deleteInboxCustomerRequestId"] = this.deleteInboxCustomerRequestId;
        data["deleteInboxCustomerFaultReason"] = this.deleteInboxCustomerFaultReason;
        data["deletionTracking"] = this.deletionTracking;
        data["clearIntegrationTracking"] = this.clearIntegrationTracking;
        data["version"] = this.version;
        data["clearTransactionCustomerIntegrationRequestId"] = this.clearTransactionCustomerIntegrationRequestId;
        data["clearTransactionCustomerIntegrationFaultReason"] = this.clearTransactionCustomerIntegrationFaultReason;
        data["purgeReportingCustomerGlDataRequestId"] = this.purgeReportingCustomerGlDataRequestId;
        data["purgeReportingCustomerGlDataFaultReason"] = this.purgeReportingCustomerGlDataFaultReason;
        data["debouncedFetchCustomerGlTransactionsTokenId"] = this.debouncedFetchCustomerGlTransactionsTokenId;
        data["validateClearIntegrationRequestId"] = this.validateClearIntegrationRequestId;
        data["clearIntegrationCutoffDate"] = this.clearIntegrationCutoffDate;
        data["glAccountsTemplate"] = this.glAccountsTemplate;
        return data;
    }
}

export interface ICustomerState {
    correlationId?: string;
    id?: number;
    currentState?: CustomerStateMachineStatus;
    customerName?: string;
    pogoClientId?: string | undefined;
    createdByEmail?: string | undefined;
    pogoClientKey?: string | undefined;
    glApiUrl?: string | undefined;
    glTestApiUrl?: string | undefined;
    sessionToken?: string | undefined;
    vatNumber?: string | undefined;
    companyEmail?: string | undefined;
    voucherReceivingEmail?: string | undefined;
    externalGlSystem?: ExternalGlSystem | undefined;
    externalGlSystemId?: number | undefined;
    lockDate?: string | undefined;
    hasSetupIntegration?: boolean;
    hasCreatedAccounts?: boolean;
    hasInvitedUsers?: boolean;
    useAiTranslatorOnPdf?: boolean;
    useAverageCostPrice?: boolean;
    usePortfolio?: boolean;
    useVisma?: boolean;
    defaultPortfolioCategoryId?: number | undefined;
    restQuantityThreshold?: number;
    restCostpriceThreshold?: number;
    defaultChartTheme?: string | undefined;
    defaultPhoneDashboard?: string | undefined;
    defaultTabletDashboard?: string | undefined;
    defaultDesktopDashboard?: string | undefined;
    closePeriodDate?: string | undefined;
    partnerId?: number | undefined;
    partner?: Partner | undefined;
    licenseOwnerId?: number | undefined;
    licenseOwner?: LicenseOwner | undefined;
    corporationId?: string | undefined;
    corporation?: Corporation | undefined;
    created?: string;
    creatingDefaultGlAccountsFaultReason?: string | undefined;
    createdById?: number | undefined;
    createdBy?: User | undefined;
    status?: CustomerStatus;
    deleteDate?: string | undefined;
    finalDeleteWarningDate?: string | undefined;
    userCustomerRoles?: UserCustomerRole[] | undefined;
    licenses?: License[] | undefined;
    instrumentTypes?: InstrumentType[] | undefined;
    customAttributes?: { [key: string]: string; } | undefined;
    internalNotes?: string | undefined;
    integrationSuspended?: boolean;
    createDefaultGlAccountsRequestId?: string | undefined;
    createOrUpdateTransactionCustomerRequestId?: string | undefined;
    createOrUpdateTransactionCustomerFaultReason?: string | undefined;
    createOrUpdateReportingCustomerRequestId?: string | undefined;
    createOrUpdateReportingCustomerFaultReason?: string | undefined;
    deleteTransactionCustomerRequestId?: string | undefined;
    deleteTransactionCustomerFaultReason?: string | undefined;
    deleteReportingCustomerRequestId?: string | undefined;
    deleteReportingCustomerFaultReason?: string | undefined;
    deleteInboxCustomerRequestId?: string | undefined;
    deleteInboxCustomerFaultReason?: string | undefined;
    deletionTracking?: number;
    clearIntegrationTracking?: number;
    version?: number;
    clearTransactionCustomerIntegrationRequestId?: string | undefined;
    clearTransactionCustomerIntegrationFaultReason?: string | undefined;
    purgeReportingCustomerGlDataRequestId?: string | undefined;
    purgeReportingCustomerGlDataFaultReason?: string | undefined;
    debouncedFetchCustomerGlTransactionsTokenId?: string | undefined;
    validateClearIntegrationRequestId?: string | undefined;
    clearIntegrationCutoffDate?: string | undefined;
    glAccountsTemplate?: GlAccountsTemplate;
}

export class ExternalGlSystem implements IExternalGlSystem {
    id?: number;
    name?: string;
    supportsWebHook?: boolean;

    constructor(data?: IExternalGlSystem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.supportsWebHook = _data["supportsWebHook"];
        }
    }

    static fromJS(data: any): ExternalGlSystem {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalGlSystem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["supportsWebHook"] = this.supportsWebHook;
        return data;
    }
}

export interface IExternalGlSystem {
    id?: number;
    name?: string;
    supportsWebHook?: boolean;
}

export class Partner implements IPartner {
    id?: number;
    partnerName?: string | undefined;
    defaultPackageDiscount?: number;
    defaultTransactionDiscount?: number;
    defaultPaymentInterval?: PaymentIntervalType | undefined;
    defaultLicenseOwnerId?: number | undefined;
    defaultLicenseOwner?: LicenseOwner | undefined;
    customers?: CustomerState[];

    constructor(data?: IPartner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.partnerName = _data["partnerName"];
            this.defaultPackageDiscount = _data["defaultPackageDiscount"];
            this.defaultTransactionDiscount = _data["defaultTransactionDiscount"];
            this.defaultPaymentInterval = _data["defaultPaymentInterval"];
            this.defaultLicenseOwnerId = _data["defaultLicenseOwnerId"];
            this.defaultLicenseOwner = _data["defaultLicenseOwner"] ? LicenseOwner.fromJS(_data["defaultLicenseOwner"]) : undefined as any;
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(CustomerState.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Partner {
        data = typeof data === 'object' ? data : {};
        let result = new Partner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["partnerName"] = this.partnerName;
        data["defaultPackageDiscount"] = this.defaultPackageDiscount;
        data["defaultTransactionDiscount"] = this.defaultTransactionDiscount;
        data["defaultPaymentInterval"] = this.defaultPaymentInterval;
        data["defaultLicenseOwnerId"] = this.defaultLicenseOwnerId;
        data["defaultLicenseOwner"] = this.defaultLicenseOwner ? this.defaultLicenseOwner.toJSON() : undefined as any;
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPartner {
    id?: number;
    partnerName?: string | undefined;
    defaultPackageDiscount?: number;
    defaultTransactionDiscount?: number;
    defaultPaymentInterval?: PaymentIntervalType | undefined;
    defaultLicenseOwnerId?: number | undefined;
    defaultLicenseOwner?: LicenseOwner | undefined;
    customers?: CustomerState[];
}

export enum PaymentIntervalType {
    Custom = 0,
    Monthly = 1,
    Quaterly = 2,
    SemiAnnual = 3,
    Annual = 4,
}

export class LicenseOwner implements ILicenseOwner {
    id?: number;
    name!: string;
    vatNumber!: string;
    address?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    created?: string;
    updated?: string | undefined;
    licenses?: License[] | undefined;

    constructor(data?: ILicenseOwner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.vatNumber = _data["vatNumber"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.created = _data["created"];
            this.updated = _data["updated"];
            if (Array.isArray(_data["licenses"])) {
                this.licenses = [] as any;
                for (let item of _data["licenses"])
                    this.licenses!.push(License.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LicenseOwner {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseOwner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["vatNumber"] = this.vatNumber;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["created"] = this.created;
        data["updated"] = this.updated;
        if (Array.isArray(this.licenses)) {
            data["licenses"] = [];
            for (let item of this.licenses)
                data["licenses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILicenseOwner {
    id?: number;
    name: string;
    vatNumber: string;
    address?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    created?: string;
    updated?: string | undefined;
    licenses?: License[] | undefined;
}

export class License implements ILicense {
    id?: number;
    name!: string;
    startDate?: string;
    packageId?: number | undefined;
    sellPrice?: number | undefined;
    paymentInterval?: PaymentIntervalType | undefined;
    lastPayment?: string | undefined;
    licenseOwnerType?: LicenseOwnerType;
    customerUuid?: string | undefined;
    partnerId?: number | undefined;
    licenseOwnerId?: number | undefined;
    transactionCountingPeriod?: TransactionCountingPeriodType | undefined;
    overridePackageDiscount?: number | undefined;
    overrideTransactionDiscount?: number | undefined;
    isFixedPrice?: boolean;

    constructor(data?: ILicense) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.startDate = _data["startDate"];
            this.packageId = _data["packageId"];
            this.sellPrice = _data["sellPrice"];
            this.paymentInterval = _data["paymentInterval"];
            this.lastPayment = _data["lastPayment"];
            this.licenseOwnerType = _data["licenseOwnerType"];
            this.customerUuid = _data["customerUuid"];
            this.partnerId = _data["partnerId"];
            this.licenseOwnerId = _data["licenseOwnerId"];
            this.transactionCountingPeriod = _data["transactionCountingPeriod"];
            this.overridePackageDiscount = _data["overridePackageDiscount"];
            this.overrideTransactionDiscount = _data["overrideTransactionDiscount"];
            this.isFixedPrice = _data["isFixedPrice"];
        }
    }

    static fromJS(data: any): License {
        data = typeof data === 'object' ? data : {};
        let result = new License();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["startDate"] = this.startDate;
        data["packageId"] = this.packageId;
        data["sellPrice"] = this.sellPrice;
        data["paymentInterval"] = this.paymentInterval;
        data["lastPayment"] = this.lastPayment;
        data["licenseOwnerType"] = this.licenseOwnerType;
        data["customerUuid"] = this.customerUuid;
        data["partnerId"] = this.partnerId;
        data["licenseOwnerId"] = this.licenseOwnerId;
        data["transactionCountingPeriod"] = this.transactionCountingPeriod;
        data["overridePackageDiscount"] = this.overridePackageDiscount;
        data["overrideTransactionDiscount"] = this.overrideTransactionDiscount;
        data["isFixedPrice"] = this.isFixedPrice;
        return data;
    }
}

export interface ILicense {
    id?: number;
    name: string;
    startDate?: string;
    packageId?: number | undefined;
    sellPrice?: number | undefined;
    paymentInterval?: PaymentIntervalType | undefined;
    lastPayment?: string | undefined;
    licenseOwnerType?: LicenseOwnerType;
    customerUuid?: string | undefined;
    partnerId?: number | undefined;
    licenseOwnerId?: number | undefined;
    transactionCountingPeriod?: TransactionCountingPeriodType | undefined;
    overridePackageDiscount?: number | undefined;
    overrideTransactionDiscount?: number | undefined;
    isFixedPrice?: boolean;
}

export enum LicenseOwnerType {
    Customer = 0,
    Partner = 1,
    PartnerCustomerOverride = 2,
    LicenseOwnerCustomerOverride = 3,
    LicenseOwner = 4,
}

export enum TransactionCountingPeriodType {
    CalendarYear = 0,
    RollingTwelveMonths = 1,
}

export enum CustomerStatus {
    New = 0,
    Active = 1,
    Test = 2,
    Inactive = 3,
}

export enum InstrumentType {
    StocksNoted = 1,
    EquityCertificate = 2,
    Bonds = 3,
    FixedIncomeFunds = 4,
    Derivatives = 5,
    Stocks = 7,
    Dividend = 8,
    Repayment = 9,
    EquityFunds = 10,
    Currency = 13,
    Bank = 14,
    ETF = 15,
    ETN = 16,
    StocksSubsidiaries = 50,
    StocksAssociatedCompanies = 51,
    Loans = 52,
    LoansSubsidiaries = 53,
    LoansAssociatedCompanies = 54,
    Property = 55,
    OtherAssets = 56,
    Partnership = 57,
    Cfd = 58,
    Etc = 59,
    ShortPosition = 60,
}

export enum GlAccountsTemplate {
    FourDigits = 4,
    SixDigits = 6,
}

export class UserRole implements IUserRole {
    id?: number;
    userId?: number;
    user?: User;
    roleId?: number;
    role?: Role;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined as any;
            this.roleId = _data["roleId"];
            this.role = _data["role"] ? Role.fromJS(_data["role"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["roleId"] = this.roleId;
        data["role"] = this.role ? this.role.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserRole {
    id?: number;
    userId?: number;
    user?: User;
    roleId?: number;
    role?: Role;
}

export class UserAcceptedEula implements IUserAcceptedEula {
    id?: number;
    userId?: number;
    user?: User | undefined;
    endUserLicenseAgreementId?: number;
    endUserLicenseAgreement?: EndUserLicenseAgreement | undefined;
    acceptedDate?: string;

    constructor(data?: IUserAcceptedEula) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined as any;
            this.endUserLicenseAgreementId = _data["endUserLicenseAgreementId"];
            this.endUserLicenseAgreement = _data["endUserLicenseAgreement"] ? EndUserLicenseAgreement.fromJS(_data["endUserLicenseAgreement"]) : undefined as any;
            this.acceptedDate = _data["acceptedDate"];
        }
    }

    static fromJS(data: any): UserAcceptedEula {
        data = typeof data === 'object' ? data : {};
        let result = new UserAcceptedEula();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["endUserLicenseAgreementId"] = this.endUserLicenseAgreementId;
        data["endUserLicenseAgreement"] = this.endUserLicenseAgreement ? this.endUserLicenseAgreement.toJSON() : undefined as any;
        data["acceptedDate"] = this.acceptedDate;
        return data;
    }
}

export interface IUserAcceptedEula {
    id?: number;
    userId?: number;
    user?: User | undefined;
    endUserLicenseAgreementId?: number;
    endUserLicenseAgreement?: EndUserLicenseAgreement | undefined;
    acceptedDate?: string;
}

export class EndUserLicenseAgreement implements IEndUserLicenseAgreement {
    id?: number;
    name!: string;
    ingress!: string;
    body!: string;
    version?: number;
    isPublished?: boolean;
    lastUpdated?: string | undefined;
    userAcceptedEulas?: UserAcceptedEula[] | undefined;

    constructor(data?: IEndUserLicenseAgreement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.ingress = _data["ingress"];
            this.body = _data["body"];
            this.version = _data["version"];
            this.isPublished = _data["isPublished"];
            this.lastUpdated = _data["lastUpdated"];
            if (Array.isArray(_data["userAcceptedEulas"])) {
                this.userAcceptedEulas = [] as any;
                for (let item of _data["userAcceptedEulas"])
                    this.userAcceptedEulas!.push(UserAcceptedEula.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EndUserLicenseAgreement {
        data = typeof data === 'object' ? data : {};
        let result = new EndUserLicenseAgreement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["ingress"] = this.ingress;
        data["body"] = this.body;
        data["version"] = this.version;
        data["isPublished"] = this.isPublished;
        data["lastUpdated"] = this.lastUpdated;
        if (Array.isArray(this.userAcceptedEulas)) {
            data["userAcceptedEulas"] = [];
            for (let item of this.userAcceptedEulas)
                data["userAcceptedEulas"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEndUserLicenseAgreement {
    id?: number;
    name: string;
    ingress: string;
    body: string;
    version?: number;
    isPublished?: boolean;
    lastUpdated?: string | undefined;
    userAcceptedEulas?: UserAcceptedEula[] | undefined;
}

export class PaymentViewModel implements IPaymentViewModel {
    id?: number;

    constructor(data?: IPaymentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PaymentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IPaymentViewModel {
    id?: number;
}

export class ExternalGlSystemViewModel implements IExternalGlSystemViewModel {
    id?: number | undefined;
    name?: string | undefined;
    supportsWebHook?: boolean | undefined;

    constructor(data?: IExternalGlSystemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.supportsWebHook = _data["supportsWebHook"];
        }
    }

    static fromJS(data: any): ExternalGlSystemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalGlSystemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["supportsWebHook"] = this.supportsWebHook;
        return data;
    }
}

export interface IExternalGlSystemViewModel {
    id?: number | undefined;
    name?: string | undefined;
    supportsWebHook?: boolean | undefined;
}

export class CreateCorporationRequest implements ICreateCorporationRequest {
    name?: string;

    constructor(data?: ICreateCorporationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateCorporationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCorporationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateCorporationRequest {
    name?: string;
}

export class CustomerLicenseAgreement implements ICustomerLicenseAgreement {
    id?: number;
    name!: string;
    ingress?: string | undefined;
    body?: string | undefined;
    version?: number;
    isPublished?: boolean;
    lastUpdated?: string;
    customerAcceptedLicenseAgreements?: CustomerAcceptedLicenseAgreement[] | undefined;

    constructor(data?: ICustomerLicenseAgreement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.ingress = _data["ingress"];
            this.body = _data["body"];
            this.version = _data["version"];
            this.isPublished = _data["isPublished"];
            this.lastUpdated = _data["lastUpdated"];
            if (Array.isArray(_data["customerAcceptedLicenseAgreements"])) {
                this.customerAcceptedLicenseAgreements = [] as any;
                for (let item of _data["customerAcceptedLicenseAgreements"])
                    this.customerAcceptedLicenseAgreements!.push(CustomerAcceptedLicenseAgreement.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerLicenseAgreement {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerLicenseAgreement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["ingress"] = this.ingress;
        data["body"] = this.body;
        data["version"] = this.version;
        data["isPublished"] = this.isPublished;
        data["lastUpdated"] = this.lastUpdated;
        if (Array.isArray(this.customerAcceptedLicenseAgreements)) {
            data["customerAcceptedLicenseAgreements"] = [];
            for (let item of this.customerAcceptedLicenseAgreements)
                data["customerAcceptedLicenseAgreements"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICustomerLicenseAgreement {
    id?: number;
    name: string;
    ingress?: string | undefined;
    body?: string | undefined;
    version?: number;
    isPublished?: boolean;
    lastUpdated?: string;
    customerAcceptedLicenseAgreements?: CustomerAcceptedLicenseAgreement[] | undefined;
}

export class CustomerAcceptedLicenseAgreement implements ICustomerAcceptedLicenseAgreement {
    id?: number;
    customerId?: number;
    customerUuid?: string;
    customerState?: CustomerState;
    customerLicenseAgreementId?: number;
    customerLicenseAgreement?: CustomerLicenseAgreement;
    acceptedDate?: string;
    acceptedByUserId?: number;
    acceptedByUser?: User | undefined;

    constructor(data?: ICustomerAcceptedLicenseAgreement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.customerUuid = _data["customerUuid"];
            this.customerState = _data["customerState"] ? CustomerState.fromJS(_data["customerState"]) : undefined as any;
            this.customerLicenseAgreementId = _data["customerLicenseAgreementId"];
            this.customerLicenseAgreement = _data["customerLicenseAgreement"] ? CustomerLicenseAgreement.fromJS(_data["customerLicenseAgreement"]) : undefined as any;
            this.acceptedDate = _data["acceptedDate"];
            this.acceptedByUserId = _data["acceptedByUserId"];
            this.acceptedByUser = _data["acceptedByUser"] ? User.fromJS(_data["acceptedByUser"]) : undefined as any;
        }
    }

    static fromJS(data: any): CustomerAcceptedLicenseAgreement {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAcceptedLicenseAgreement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["customerUuid"] = this.customerUuid;
        data["customerState"] = this.customerState ? this.customerState.toJSON() : undefined as any;
        data["customerLicenseAgreementId"] = this.customerLicenseAgreementId;
        data["customerLicenseAgreement"] = this.customerLicenseAgreement ? this.customerLicenseAgreement.toJSON() : undefined as any;
        data["acceptedDate"] = this.acceptedDate;
        data["acceptedByUserId"] = this.acceptedByUserId;
        data["acceptedByUser"] = this.acceptedByUser ? this.acceptedByUser.toJSON() : undefined as any;
        return data;
    }
}

export interface ICustomerAcceptedLicenseAgreement {
    id?: number;
    customerId?: number;
    customerUuid?: string;
    customerState?: CustomerState;
    customerLicenseAgreementId?: number;
    customerLicenseAgreement?: CustomerLicenseAgreement;
    acceptedDate?: string;
    acceptedByUserId?: number;
    acceptedByUser?: User | undefined;
}

export class CustomerLookupViewModel implements ICustomerLookupViewModel {
    id?: number;
    uuid?: string;
    name?: string;

    constructor(data?: ICustomerLookupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uuid = _data["uuid"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CustomerLookupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerLookupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uuid"] = this.uuid;
        data["name"] = this.name;
        return data;
    }
}

export interface ICustomerLookupViewModel {
    id?: number;
    uuid?: string;
    name?: string;
}

export class MyCustomerViewModel implements IMyCustomerViewModel {
    uuid?: string;
    companyId?: number;
    identityId?: number;
    name?: string | undefined;
    externalGlSystem?: string | undefined;
    externalId?: string | undefined;
    closePeriodDate?: string | undefined;
    voucherReceivingEmail?: string | undefined;
    vatNumber?: string | undefined;
    defaultChartTheme?: string | undefined;
    defaultPhoneDashboard?: string | undefined;
    defaultTabletDashboard?: string | undefined;
    defaultDesktopDashboard?: string | undefined;
    useAverageCostPrice?: boolean;
    usePortfolio?: boolean;
    defaultPortfolioCategoryId?: number | undefined;

    constructor(data?: IMyCustomerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uuid = _data["uuid"];
            this.companyId = _data["companyId"];
            this.identityId = _data["identityId"];
            this.name = _data["name"];
            this.externalGlSystem = _data["externalGlSystem"];
            this.externalId = _data["externalId"];
            this.closePeriodDate = _data["closePeriodDate"];
            this.voucherReceivingEmail = _data["voucherReceivingEmail"];
            this.vatNumber = _data["vatNumber"];
            this.defaultChartTheme = _data["defaultChartTheme"];
            this.defaultPhoneDashboard = _data["defaultPhoneDashboard"];
            this.defaultTabletDashboard = _data["defaultTabletDashboard"];
            this.defaultDesktopDashboard = _data["defaultDesktopDashboard"];
            this.useAverageCostPrice = _data["useAverageCostPrice"];
            this.usePortfolio = _data["usePortfolio"];
            this.defaultPortfolioCategoryId = _data["defaultPortfolioCategoryId"];
        }
    }

    static fromJS(data: any): MyCustomerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MyCustomerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uuid"] = this.uuid;
        data["companyId"] = this.companyId;
        data["identityId"] = this.identityId;
        data["name"] = this.name;
        data["externalGlSystem"] = this.externalGlSystem;
        data["externalId"] = this.externalId;
        data["closePeriodDate"] = this.closePeriodDate;
        data["voucherReceivingEmail"] = this.voucherReceivingEmail;
        data["vatNumber"] = this.vatNumber;
        data["defaultChartTheme"] = this.defaultChartTheme;
        data["defaultPhoneDashboard"] = this.defaultPhoneDashboard;
        data["defaultTabletDashboard"] = this.defaultTabletDashboard;
        data["defaultDesktopDashboard"] = this.defaultDesktopDashboard;
        data["useAverageCostPrice"] = this.useAverageCostPrice;
        data["usePortfolio"] = this.usePortfolio;
        data["defaultPortfolioCategoryId"] = this.defaultPortfolioCategoryId;
        return data;
    }
}

export interface IMyCustomerViewModel {
    uuid?: string;
    companyId?: number;
    identityId?: number;
    name?: string | undefined;
    externalGlSystem?: string | undefined;
    externalId?: string | undefined;
    closePeriodDate?: string | undefined;
    voucherReceivingEmail?: string | undefined;
    vatNumber?: string | undefined;
    defaultChartTheme?: string | undefined;
    defaultPhoneDashboard?: string | undefined;
    defaultTabletDashboard?: string | undefined;
    defaultDesktopDashboard?: string | undefined;
    useAverageCostPrice?: boolean;
    usePortfolio?: boolean;
    defaultPortfolioCategoryId?: number | undefined;
}

export class QueryWebhookSubscriptionResponseContract implements IQueryWebhookSubscriptionResponseContract {
    identityId?: number;
    glSystemId?: number | undefined;
    glSystemName?: string | undefined;
    glSystemNameTest?: string | undefined;
    transactionSubscriptionStatus?: WebhookSubscriptionStatus | undefined;
    accountsSubscriptionStatus?: WebhookSubscriptionStatus | undefined;

    constructor(data?: IQueryWebhookSubscriptionResponseContract) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identityId = _data["identityId"];
            this.glSystemId = _data["glSystemId"];
            this.glSystemName = _data["glSystemName"];
            this.glSystemNameTest = _data["glSystemNameTest"];
            this.transactionSubscriptionStatus = _data["transactionSubscriptionStatus"];
            this.accountsSubscriptionStatus = _data["accountsSubscriptionStatus"];
        }
    }

    static fromJS(data: any): QueryWebhookSubscriptionResponseContract {
        data = typeof data === 'object' ? data : {};
        let result = new QueryWebhookSubscriptionResponseContract();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identityId"] = this.identityId;
        data["glSystemId"] = this.glSystemId;
        data["glSystemName"] = this.glSystemName;
        data["glSystemNameTest"] = this.glSystemNameTest;
        data["transactionSubscriptionStatus"] = this.transactionSubscriptionStatus;
        data["accountsSubscriptionStatus"] = this.accountsSubscriptionStatus;
        return data;
    }
}

export interface IQueryWebhookSubscriptionResponseContract {
    identityId?: number;
    glSystemId?: number | undefined;
    glSystemName?: string | undefined;
    glSystemNameTest?: string | undefined;
    transactionSubscriptionStatus?: WebhookSubscriptionStatus | undefined;
    accountsSubscriptionStatus?: WebhookSubscriptionStatus | undefined;
}

export enum WebhookSubscriptionStatus {
    Active = 1,
    Inactive = 2,
}

export class IntegrationSystemResponse implements IIntegrationSystemResponse {
    name?: string;
    externalGlSystem?: ExternalGlSystemEnum;
    apiUrl?: string;
    testApiUrl?: string;

    constructor(data?: IIntegrationSystemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.externalGlSystem = _data["externalGlSystem"];
            this.apiUrl = _data["apiUrl"];
            this.testApiUrl = _data["testApiUrl"];
        }
    }

    static fromJS(data: any): IntegrationSystemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationSystemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["externalGlSystem"] = this.externalGlSystem;
        data["apiUrl"] = this.apiUrl;
        data["testApiUrl"] = this.testApiUrl;
        return data;
    }
}

export interface IIntegrationSystemResponse {
    name?: string;
    externalGlSystem?: ExternalGlSystemEnum;
    apiUrl?: string;
    testApiUrl?: string;
}

export enum ExternalGlSystemEnum {
    None = 0,
    Pogo = 3,
    Tripletex = 6,
    Unimicro = 7,
    Xledger = 8,
    VismaBusinessSftp = 9,
    Dynamics365Excel = 10,
    TwoFourSevenOfficeExcel = 11,
    Finago = 12,
}

export class ValidateClearIntegrationResponse implements IValidateClearIntegrationResponse {
    isValid?: boolean;
    blockingVouchers?: BlockingVoucher[];

    constructor(data?: IValidateClearIntegrationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            if (Array.isArray(_data["blockingVouchers"])) {
                this.blockingVouchers = [] as any;
                for (let item of _data["blockingVouchers"])
                    this.blockingVouchers!.push(BlockingVoucher.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidateClearIntegrationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateClearIntegrationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        if (Array.isArray(this.blockingVouchers)) {
            data["blockingVouchers"] = [];
            for (let item of this.blockingVouchers)
                data["blockingVouchers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IValidateClearIntegrationResponse {
    isValid?: boolean;
    blockingVouchers?: BlockingVoucher[];
}

export class BlockingVoucher implements IBlockingVoucher {
    voucherId?: string;
    currentState?: string;

    constructor(data?: IBlockingVoucher) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voucherId = _data["voucherId"];
            this.currentState = _data["currentState"];
        }
    }

    static fromJS(data: any): BlockingVoucher {
        data = typeof data === 'object' ? data : {};
        let result = new BlockingVoucher();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherId"] = this.voucherId;
        data["currentState"] = this.currentState;
        return data;
    }
}

export interface IBlockingVoucher {
    voucherId?: string;
    currentState?: string;
}

export class FlowCustomerModel implements IFlowCustomerModel {
    customerName?: string;
    clientId?: string;
    clientKey?: string;
    vatNumber?: string;
    identityId?: number | undefined;

    constructor(data?: IFlowCustomerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerName = _data["customerName"];
            this.clientId = _data["clientId"];
            this.clientKey = _data["clientKey"];
            this.vatNumber = _data["vatNumber"];
            this.identityId = _data["identityId"];
        }
    }

    static fromJS(data: any): FlowCustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new FlowCustomerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["clientId"] = this.clientId;
        data["clientKey"] = this.clientKey;
        data["vatNumber"] = this.vatNumber;
        data["identityId"] = this.identityId;
        return data;
    }
}

export interface IFlowCustomerModel {
    customerName?: string;
    clientId?: string;
    clientKey?: string;
    vatNumber?: string;
    identityId?: number | undefined;
}

export class ExportFile implements IExportFile {
    path?: string;
    lastModified?: string;
    contentType?: string;

    constructor(data?: IExportFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.path = _data["path"];
            this.lastModified = _data["lastModified"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): ExportFile {
        data = typeof data === 'object' ? data : {};
        let result = new ExportFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path;
        data["lastModified"] = this.lastModified;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface IExportFile {
    path?: string;
    lastModified?: string;
    contentType?: string;
}

export class InvoiceLineItemViewModel implements IInvoiceLineItemViewModel {
    id?: number;
    invoiceId?: number;
    type?: string;
    description?: string | undefined;
    quantity?: number;
    unitPrice?: number;
    discountPercentage?: number;
    lineTotal?: number;
    discountAmount?: number;
    lineFinalAmount?: number;
    appliedFrequency?: string | undefined;
    externalProductId?: string | undefined;
    created?: string;

    constructor(data?: IInvoiceLineItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceId = _data["invoiceId"];
            this.type = _data["type"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.discountPercentage = _data["discountPercentage"];
            this.lineTotal = _data["lineTotal"];
            this.discountAmount = _data["discountAmount"];
            this.lineFinalAmount = _data["lineFinalAmount"];
            this.appliedFrequency = _data["appliedFrequency"];
            this.externalProductId = _data["externalProductId"];
            this.created = _data["created"];
        }
    }

    static fromJS(data: any): InvoiceLineItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceLineItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceId"] = this.invoiceId;
        data["type"] = this.type;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["discountPercentage"] = this.discountPercentage;
        data["lineTotal"] = this.lineTotal;
        data["discountAmount"] = this.discountAmount;
        data["lineFinalAmount"] = this.lineFinalAmount;
        data["appliedFrequency"] = this.appliedFrequency;
        data["externalProductId"] = this.externalProductId;
        data["created"] = this.created;
        return data;
    }
}

export interface IInvoiceLineItemViewModel {
    id?: number;
    invoiceId?: number;
    type?: string;
    description?: string | undefined;
    quantity?: number;
    unitPrice?: number;
    discountPercentage?: number;
    lineTotal?: number;
    discountAmount?: number;
    lineFinalAmount?: number;
    appliedFrequency?: string | undefined;
    externalProductId?: string | undefined;
    created?: string;
}

export class CreateLineItemRequest implements ICreateLineItemRequest {
    invoiceId?: number;
    type?: string;
    description?: string | undefined;
    quantity?: number;
    unitPrice?: number;
    discountPercentage?: number;
    lineTotal?: number;
    discountAmount?: number;
    lineFinalAmount?: number;
    appliedFrequency?: string | undefined;

    constructor(data?: ICreateLineItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            this.type = _data["type"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.discountPercentage = _data["discountPercentage"];
            this.lineTotal = _data["lineTotal"];
            this.discountAmount = _data["discountAmount"];
            this.lineFinalAmount = _data["lineFinalAmount"];
            this.appliedFrequency = _data["appliedFrequency"];
        }
    }

    static fromJS(data: any): CreateLineItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLineItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["type"] = this.type;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["discountPercentage"] = this.discountPercentage;
        data["lineTotal"] = this.lineTotal;
        data["discountAmount"] = this.discountAmount;
        data["lineFinalAmount"] = this.lineFinalAmount;
        data["appliedFrequency"] = this.appliedFrequency;
        return data;
    }
}

export interface ICreateLineItemRequest {
    invoiceId?: number;
    type?: string;
    description?: string | undefined;
    quantity?: number;
    unitPrice?: number;
    discountPercentage?: number;
    lineTotal?: number;
    discountAmount?: number;
    lineFinalAmount?: number;
    appliedFrequency?: string | undefined;
}

export class UpdateLineItemRequest implements IUpdateLineItemRequest {
    description?: string | undefined;
    discountPercentage?: number | undefined;

    constructor(data?: IUpdateLineItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.discountPercentage = _data["discountPercentage"];
        }
    }

    static fromJS(data: any): UpdateLineItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLineItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["discountPercentage"] = this.discountPercentage;
        return data;
    }
}

export interface IUpdateLineItemRequest {
    description?: string | undefined;
    discountPercentage?: number | undefined;
}

export class InvoicingReport implements IInvoicingReport {
    rows?: InvoiceReportRow[];
    totalGrossAmount?: number;
    totalDiscounts?: number;
    totalNetAmount?: number;
    totalLicensesReported?: number;
    summaryByVat?: { [key: string]: number; };
    licenseCountByVat?: { [key: string]: number; };

    constructor(data?: IInvoicingReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(InvoiceReportRow.fromJS(item));
            }
            this.totalGrossAmount = _data["totalGrossAmount"];
            this.totalDiscounts = _data["totalDiscounts"];
            this.totalNetAmount = _data["totalNetAmount"];
            this.totalLicensesReported = _data["totalLicensesReported"];
            if (_data["summaryByVat"]) {
                this.summaryByVat = {} as any;
                for (let key in _data["summaryByVat"]) {
                    if (_data["summaryByVat"].hasOwnProperty(key))
                        (this.summaryByVat as any)![key] = _data["summaryByVat"][key];
                }
            }
            if (_data["licenseCountByVat"]) {
                this.licenseCountByVat = {} as any;
                for (let key in _data["licenseCountByVat"]) {
                    if (_data["licenseCountByVat"].hasOwnProperty(key))
                        (this.licenseCountByVat as any)![key] = _data["licenseCountByVat"][key];
                }
            }
        }
    }

    static fromJS(data: any): InvoicingReport {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicingReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalGrossAmount"] = this.totalGrossAmount;
        data["totalDiscounts"] = this.totalDiscounts;
        data["totalNetAmount"] = this.totalNetAmount;
        data["totalLicensesReported"] = this.totalLicensesReported;
        if (this.summaryByVat) {
            data["summaryByVat"] = {};
            for (let key in this.summaryByVat) {
                if (this.summaryByVat.hasOwnProperty(key))
                    (data["summaryByVat"] as any)[key] = (this.summaryByVat as any)[key];
            }
        }
        if (this.licenseCountByVat) {
            data["licenseCountByVat"] = {};
            for (let key in this.licenseCountByVat) {
                if (this.licenseCountByVat.hasOwnProperty(key))
                    (data["licenseCountByVat"] as any)[key] = (this.licenseCountByVat as any)[key];
            }
        }
        return data;
    }
}

export interface IInvoicingReport {
    rows?: InvoiceReportRow[];
    totalGrossAmount?: number;
    totalDiscounts?: number;
    totalNetAmount?: number;
    totalLicensesReported?: number;
    summaryByVat?: { [key: string]: number; };
    licenseCountByVat?: { [key: string]: number; };
}

export class InvoiceReportRow implements IInvoiceReportRow {
    licenseId?: number;
    licenseName?: string;
    customerUuid?: string | undefined;
    customerName?: string | undefined;
    partnerId?: number | undefined;
    partnerName?: string | undefined;
    licenseOwnerId?: number | undefined;
    licenseOwnerName?: string | undefined;
    vatNumber?: string;
    sellPrice?: number;
    packageDiscount?: number;
    packageDiscountAmount?: number;
    transactionCount?: number;
    transactionPrice?: number;
    transactionDiscount?: number;
    transactionDiscountAmount?: number;
    totalBeforeDiscount?: number;
    totalDiscount?: number;
    finalAmount?: number;
    frequency?: string | undefined;
    licenseStartDate?: string;
    licenseOwnerType?: string | undefined;

    constructor(data?: IInvoiceReportRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseId = _data["licenseId"];
            this.licenseName = _data["licenseName"];
            this.customerUuid = _data["customerUuid"];
            this.customerName = _data["customerName"];
            this.partnerId = _data["partnerId"];
            this.partnerName = _data["partnerName"];
            this.licenseOwnerId = _data["licenseOwnerId"];
            this.licenseOwnerName = _data["licenseOwnerName"];
            this.vatNumber = _data["vatNumber"];
            this.sellPrice = _data["sellPrice"];
            this.packageDiscount = _data["packageDiscount"];
            this.packageDiscountAmount = _data["packageDiscountAmount"];
            this.transactionCount = _data["transactionCount"];
            this.transactionPrice = _data["transactionPrice"];
            this.transactionDiscount = _data["transactionDiscount"];
            this.transactionDiscountAmount = _data["transactionDiscountAmount"];
            this.totalBeforeDiscount = _data["totalBeforeDiscount"];
            this.totalDiscount = _data["totalDiscount"];
            this.finalAmount = _data["finalAmount"];
            this.frequency = _data["frequency"];
            this.licenseStartDate = _data["licenseStartDate"];
            this.licenseOwnerType = _data["licenseOwnerType"];
        }
    }

    static fromJS(data: any): InvoiceReportRow {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceReportRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseId"] = this.licenseId;
        data["licenseName"] = this.licenseName;
        data["customerUuid"] = this.customerUuid;
        data["customerName"] = this.customerName;
        data["partnerId"] = this.partnerId;
        data["partnerName"] = this.partnerName;
        data["licenseOwnerId"] = this.licenseOwnerId;
        data["licenseOwnerName"] = this.licenseOwnerName;
        data["vatNumber"] = this.vatNumber;
        data["sellPrice"] = this.sellPrice;
        data["packageDiscount"] = this.packageDiscount;
        data["packageDiscountAmount"] = this.packageDiscountAmount;
        data["transactionCount"] = this.transactionCount;
        data["transactionPrice"] = this.transactionPrice;
        data["transactionDiscount"] = this.transactionDiscount;
        data["transactionDiscountAmount"] = this.transactionDiscountAmount;
        data["totalBeforeDiscount"] = this.totalBeforeDiscount;
        data["totalDiscount"] = this.totalDiscount;
        data["finalAmount"] = this.finalAmount;
        data["frequency"] = this.frequency;
        data["licenseStartDate"] = this.licenseStartDate;
        data["licenseOwnerType"] = this.licenseOwnerType;
        return data;
    }
}

export interface IInvoiceReportRow {
    licenseId?: number;
    licenseName?: string;
    customerUuid?: string | undefined;
    customerName?: string | undefined;
    partnerId?: number | undefined;
    partnerName?: string | undefined;
    licenseOwnerId?: number | undefined;
    licenseOwnerName?: string | undefined;
    vatNumber?: string;
    sellPrice?: number;
    packageDiscount?: number;
    packageDiscountAmount?: number;
    transactionCount?: number;
    transactionPrice?: number;
    transactionDiscount?: number;
    transactionDiscountAmount?: number;
    totalBeforeDiscount?: number;
    totalDiscount?: number;
    finalAmount?: number;
    frequency?: string | undefined;
    licenseStartDate?: string;
    licenseOwnerType?: string | undefined;
}

export class InvoiceViewModel implements IInvoiceViewModel {
    id?: number;
    licenseId?: number;
    customerUuid?: string | undefined;
    partnerId?: number | undefined;
    licenseOwnerId?: number | undefined;
    invoiceNumber?: string;
    vatNumber?: string;
    invoiceDate?: string;
    dueDate?: string | undefined;
    paidDate?: string | undefined;
    totalAmount?: number;
    totalDiscountAmount?: number;
    finalAmount?: number;
    status?: string;
    recipientType?: string | undefined;
    recipientName?: string | undefined;
    customerCount?: number;
    billingPeriodStart?: string;
    billingPeriodEnd?: string;
    lineItems?: InvoiceLineItemViewModel[] | undefined;
    created?: string;
    updated?: string | undefined;

    constructor(data?: IInvoiceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.licenseId = _data["licenseId"];
            this.customerUuid = _data["customerUuid"];
            this.partnerId = _data["partnerId"];
            this.licenseOwnerId = _data["licenseOwnerId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.vatNumber = _data["vatNumber"];
            this.invoiceDate = _data["invoiceDate"];
            this.dueDate = _data["dueDate"];
            this.paidDate = _data["paidDate"];
            this.totalAmount = _data["totalAmount"];
            this.totalDiscountAmount = _data["totalDiscountAmount"];
            this.finalAmount = _data["finalAmount"];
            this.status = _data["status"];
            this.recipientType = _data["recipientType"];
            this.recipientName = _data["recipientName"];
            this.customerCount = _data["customerCount"];
            this.billingPeriodStart = _data["billingPeriodStart"];
            this.billingPeriodEnd = _data["billingPeriodEnd"];
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [] as any;
                for (let item of _data["lineItems"])
                    this.lineItems!.push(InvoiceLineItemViewModel.fromJS(item));
            }
            this.created = _data["created"];
            this.updated = _data["updated"];
        }
    }

    static fromJS(data: any): InvoiceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["licenseId"] = this.licenseId;
        data["customerUuid"] = this.customerUuid;
        data["partnerId"] = this.partnerId;
        data["licenseOwnerId"] = this.licenseOwnerId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["vatNumber"] = this.vatNumber;
        data["invoiceDate"] = this.invoiceDate;
        data["dueDate"] = this.dueDate;
        data["paidDate"] = this.paidDate;
        data["totalAmount"] = this.totalAmount;
        data["totalDiscountAmount"] = this.totalDiscountAmount;
        data["finalAmount"] = this.finalAmount;
        data["status"] = this.status;
        data["recipientType"] = this.recipientType;
        data["recipientName"] = this.recipientName;
        data["customerCount"] = this.customerCount;
        data["billingPeriodStart"] = this.billingPeriodStart;
        data["billingPeriodEnd"] = this.billingPeriodEnd;
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["created"] = this.created;
        data["updated"] = this.updated;
        return data;
    }
}

export interface IInvoiceViewModel {
    id?: number;
    licenseId?: number;
    customerUuid?: string | undefined;
    partnerId?: number | undefined;
    licenseOwnerId?: number | undefined;
    invoiceNumber?: string;
    vatNumber?: string;
    invoiceDate?: string;
    dueDate?: string | undefined;
    paidDate?: string | undefined;
    totalAmount?: number;
    totalDiscountAmount?: number;
    finalAmount?: number;
    status?: string;
    recipientType?: string | undefined;
    recipientName?: string | undefined;
    customerCount?: number;
    billingPeriodStart?: string;
    billingPeriodEnd?: string;
    lineItems?: InvoiceLineItemViewModel[] | undefined;
    created?: string;
    updated?: string | undefined;
}

export class UpdateInvoiceRequest implements IUpdateInvoiceRequest {
    status?: string | undefined;
    dueDate?: string | undefined;
    paidDate?: string | undefined;

    constructor(data?: IUpdateInvoiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.dueDate = _data["dueDate"];
            this.paidDate = _data["paidDate"];
        }
    }

    static fromJS(data: any): UpdateInvoiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvoiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["dueDate"] = this.dueDate;
        data["paidDate"] = this.paidDate;
        return data;
    }
}

export interface IUpdateInvoiceRequest {
    status?: string | undefined;
    dueDate?: string | undefined;
    paidDate?: string | undefined;
}

export class InvoiceGenerationPreview implements IInvoiceGenerationPreview {
    totalLicenses?: number;
    totalInvoices?: number;
    skippedAlreadyInvoiced?: number;
    groups?: InvoicePreviewGroup[];

    constructor(data?: IInvoiceGenerationPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalLicenses = _data["totalLicenses"];
            this.totalInvoices = _data["totalInvoices"];
            this.skippedAlreadyInvoiced = _data["skippedAlreadyInvoiced"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(InvoicePreviewGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoiceGenerationPreview {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceGenerationPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalLicenses"] = this.totalLicenses;
        data["totalInvoices"] = this.totalInvoices;
        data["skippedAlreadyInvoiced"] = this.skippedAlreadyInvoiced;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInvoiceGenerationPreview {
    totalLicenses?: number;
    totalInvoices?: number;
    skippedAlreadyInvoiced?: number;
    groups?: InvoicePreviewGroup[];
}

export class InvoicePreviewGroup implements IInvoicePreviewGroup {
    groupType?: string;
    recipientName?: string;
    customerUuid?: string | undefined;
    partnerId?: number | undefined;
    licenseOwnerId?: number | undefined;
    vatNumber?: string | undefined;
    customerCount?: number;
    estimatedGross?: number;
    estimatedDiscount?: number;
    estimatedTotal?: number;
    licenses?: LicensePreviewItem[];
    estimatedLineItems?: PreviewLineItem[];

    constructor(data?: IInvoicePreviewGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupType = _data["groupType"];
            this.recipientName = _data["recipientName"];
            this.customerUuid = _data["customerUuid"];
            this.partnerId = _data["partnerId"];
            this.licenseOwnerId = _data["licenseOwnerId"];
            this.vatNumber = _data["vatNumber"];
            this.customerCount = _data["customerCount"];
            this.estimatedGross = _data["estimatedGross"];
            this.estimatedDiscount = _data["estimatedDiscount"];
            this.estimatedTotal = _data["estimatedTotal"];
            if (Array.isArray(_data["licenses"])) {
                this.licenses = [] as any;
                for (let item of _data["licenses"])
                    this.licenses!.push(LicensePreviewItem.fromJS(item));
            }
            if (Array.isArray(_data["estimatedLineItems"])) {
                this.estimatedLineItems = [] as any;
                for (let item of _data["estimatedLineItems"])
                    this.estimatedLineItems!.push(PreviewLineItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoicePreviewGroup {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicePreviewGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupType"] = this.groupType;
        data["recipientName"] = this.recipientName;
        data["customerUuid"] = this.customerUuid;
        data["partnerId"] = this.partnerId;
        data["licenseOwnerId"] = this.licenseOwnerId;
        data["vatNumber"] = this.vatNumber;
        data["customerCount"] = this.customerCount;
        data["estimatedGross"] = this.estimatedGross;
        data["estimatedDiscount"] = this.estimatedDiscount;
        data["estimatedTotal"] = this.estimatedTotal;
        if (Array.isArray(this.licenses)) {
            data["licenses"] = [];
            for (let item of this.licenses)
                data["licenses"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.estimatedLineItems)) {
            data["estimatedLineItems"] = [];
            for (let item of this.estimatedLineItems)
                data["estimatedLineItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInvoicePreviewGroup {
    groupType?: string;
    recipientName?: string;
    customerUuid?: string | undefined;
    partnerId?: number | undefined;
    licenseOwnerId?: number | undefined;
    vatNumber?: string | undefined;
    customerCount?: number;
    estimatedGross?: number;
    estimatedDiscount?: number;
    estimatedTotal?: number;
    licenses?: LicensePreviewItem[];
    estimatedLineItems?: PreviewLineItem[];
}

export class LicensePreviewItem implements ILicensePreviewItem {
    licenseId?: number;
    licenseName?: string;
    packageName?: string | undefined;
    sellPrice?: number;
    discountPercentage?: number | undefined;
    transactionDiscountPercentage?: number | undefined;
    discountAmount?: number;
    estimatedNet?: number;
    paymentInterval?: string;
    monthsCovered?: number;
    customerCount?: number;
    additionalTransactionPrice?: number;
    includedTransactionCount?: number;

    constructor(data?: ILicensePreviewItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseId = _data["licenseId"];
            this.licenseName = _data["licenseName"];
            this.packageName = _data["packageName"];
            this.sellPrice = _data["sellPrice"];
            this.discountPercentage = _data["discountPercentage"];
            this.transactionDiscountPercentage = _data["transactionDiscountPercentage"];
            this.discountAmount = _data["discountAmount"];
            this.estimatedNet = _data["estimatedNet"];
            this.paymentInterval = _data["paymentInterval"];
            this.monthsCovered = _data["monthsCovered"];
            this.customerCount = _data["customerCount"];
            this.additionalTransactionPrice = _data["additionalTransactionPrice"];
            this.includedTransactionCount = _data["includedTransactionCount"];
        }
    }

    static fromJS(data: any): LicensePreviewItem {
        data = typeof data === 'object' ? data : {};
        let result = new LicensePreviewItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseId"] = this.licenseId;
        data["licenseName"] = this.licenseName;
        data["packageName"] = this.packageName;
        data["sellPrice"] = this.sellPrice;
        data["discountPercentage"] = this.discountPercentage;
        data["transactionDiscountPercentage"] = this.transactionDiscountPercentage;
        data["discountAmount"] = this.discountAmount;
        data["estimatedNet"] = this.estimatedNet;
        data["paymentInterval"] = this.paymentInterval;
        data["monthsCovered"] = this.monthsCovered;
        data["customerCount"] = this.customerCount;
        data["additionalTransactionPrice"] = this.additionalTransactionPrice;
        data["includedTransactionCount"] = this.includedTransactionCount;
        return data;
    }
}

export interface ILicensePreviewItem {
    licenseId?: number;
    licenseName?: string;
    packageName?: string | undefined;
    sellPrice?: number;
    discountPercentage?: number | undefined;
    transactionDiscountPercentage?: number | undefined;
    discountAmount?: number;
    estimatedNet?: number;
    paymentInterval?: string;
    monthsCovered?: number;
    customerCount?: number;
    additionalTransactionPrice?: number;
    includedTransactionCount?: number;
}

export class PreviewLineItem implements IPreviewLineItem {
    licenseName?: string;
    type?: string;
    description?: string;
    quantity?: number;
    unitPrice?: number;
    discountPercentage?: number;
    lineTotal?: number;
    discountAmount?: number;
    lineFinalAmount?: number;
    externalProductId?: string | undefined;

    constructor(data?: IPreviewLineItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseName = _data["licenseName"];
            this.type = _data["type"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.discountPercentage = _data["discountPercentage"];
            this.lineTotal = _data["lineTotal"];
            this.discountAmount = _data["discountAmount"];
            this.lineFinalAmount = _data["lineFinalAmount"];
            this.externalProductId = _data["externalProductId"];
        }
    }

    static fromJS(data: any): PreviewLineItem {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewLineItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseName"] = this.licenseName;
        data["type"] = this.type;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["discountPercentage"] = this.discountPercentage;
        data["lineTotal"] = this.lineTotal;
        data["discountAmount"] = this.discountAmount;
        data["lineFinalAmount"] = this.lineFinalAmount;
        data["externalProductId"] = this.externalProductId;
        return data;
    }
}

export interface IPreviewLineItem {
    licenseName?: string;
    type?: string;
    description?: string;
    quantity?: number;
    unitPrice?: number;
    discountPercentage?: number;
    lineTotal?: number;
    discountAmount?: number;
    lineFinalAmount?: number;
    externalProductId?: string | undefined;
}

export class GenerationPeriodRequest implements IGenerationPeriodRequest {
    year?: number;
    month?: number;
    intervalFilter?: PaymentIntervalType | undefined;

    constructor(data?: IGenerationPeriodRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.intervalFilter = _data["intervalFilter"];
        }
    }

    static fromJS(data: any): GenerationPeriodRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GenerationPeriodRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["intervalFilter"] = this.intervalFilter;
        return data;
    }
}

export interface IGenerationPeriodRequest {
    year?: number;
    month?: number;
    intervalFilter?: PaymentIntervalType | undefined;
}

export class GenerationResultViewModel implements IGenerationResultViewModel {
    invoicesCreated?: number;
    licensesProcessed?: number;
    skipped?: number;
    errors?: string[];
    invoices?: InvoiceViewModel[];

    constructor(data?: IGenerationResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoicesCreated = _data["invoicesCreated"];
            this.licensesProcessed = _data["licensesProcessed"];
            this.skipped = _data["skipped"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(InvoiceViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GenerationResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GenerationResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoicesCreated"] = this.invoicesCreated;
        data["licensesProcessed"] = this.licensesProcessed;
        data["skipped"] = this.skipped;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGenerationResultViewModel {
    invoicesCreated?: number;
    licensesProcessed?: number;
    skipped?: number;
    errors?: string[];
    invoices?: InvoiceViewModel[];
}

export class MonthlyTransactionCount implements IMonthlyTransactionCount {
    id?: number;
    companyIdentityId?: number;
    year?: number;
    month?: number;
    transactionCount?: number;
    lastUpdated?: string;

    constructor(data?: IMonthlyTransactionCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyIdentityId = _data["companyIdentityId"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.transactionCount = _data["transactionCount"];
            this.lastUpdated = _data["lastUpdated"];
        }
    }

    static fromJS(data: any): MonthlyTransactionCount {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyTransactionCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyIdentityId"] = this.companyIdentityId;
        data["year"] = this.year;
        data["month"] = this.month;
        data["transactionCount"] = this.transactionCount;
        data["lastUpdated"] = this.lastUpdated;
        return data;
    }
}

export interface IMonthlyTransactionCount {
    id?: number;
    companyIdentityId?: number;
    year?: number;
    month?: number;
    transactionCount?: number;
    lastUpdated?: string;
}

export class CreateLicenseOwnerRequest implements ICreateLicenseOwnerRequest {
    name?: string;
    vatNumber?: string;
    address?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: ICreateLicenseOwnerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.vatNumber = _data["vatNumber"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): CreateLicenseOwnerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLicenseOwnerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["vatNumber"] = this.vatNumber;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ICreateLicenseOwnerRequest {
    name?: string;
    vatNumber?: string;
    address?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export class UpdateLicenseOwnerRequest implements IUpdateLicenseOwnerRequest {
    name?: string;
    vatNumber?: string;
    address?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: IUpdateLicenseOwnerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.vatNumber = _data["vatNumber"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): UpdateLicenseOwnerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLicenseOwnerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["vatNumber"] = this.vatNumber;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IUpdateLicenseOwnerRequest {
    name?: string;
    vatNumber?: string;
    address?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export class Module implements IModule {
    id?: number;
    name!: string;
    description?: string | undefined;
    moduleEntities?: ModuleEntity[] | undefined;
    sellPrice?: number;

    constructor(data?: IModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["moduleEntities"])) {
                this.moduleEntities = [] as any;
                for (let item of _data["moduleEntities"])
                    this.moduleEntities!.push(ModuleEntity.fromJS(item));
            }
            this.sellPrice = _data["sellPrice"];
        }
    }

    static fromJS(data: any): Module {
        data = typeof data === 'object' ? data : {};
        let result = new Module();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.moduleEntities)) {
            data["moduleEntities"] = [];
            for (let item of this.moduleEntities)
                data["moduleEntities"].push(item ? item.toJSON() : undefined as any);
        }
        data["sellPrice"] = this.sellPrice;
        return data;
    }
}

export interface IModule {
    id?: number;
    name: string;
    description?: string | undefined;
    moduleEntities?: ModuleEntity[] | undefined;
    sellPrice?: number;
}

export class ModuleEntity implements IModuleEntity {
    id?: number;
    moduleId?: number;
    module?: Module;
    entity!: string;

    constructor(data?: IModuleEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.moduleId = _data["moduleId"];
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : undefined as any;
            this.entity = _data["entity"];
        }
    }

    static fromJS(data: any): ModuleEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["moduleId"] = this.moduleId;
        data["module"] = this.module ? this.module.toJSON() : undefined as any;
        data["entity"] = this.entity;
        return data;
    }
}

export interface IModuleEntity {
    id?: number;
    moduleId?: number;
    module?: Module;
    entity: string;
}

export class Package implements IPackage {
    id?: number;
    name!: string;
    sellPrice?: number;
    includedTransactionCount?: number;
    additionalTransactionPrice?: number;
    useFixedPrice?: boolean;
    defaultTransactionCountingPeriod?: TransactionCountingPeriodType;
    useWithPartner?: boolean;
    useWithCustomer?: boolean;
    useWithLicenseOwnerCustomerOverride?: boolean;
    useWithPartnerCustomerOverride?: boolean;
    useWithLicenseOwner?: boolean;
    externalProductId?: string | undefined;
    partnerId?: number | undefined;
    partner?: Partner | undefined;
    packageModules?: PackageModule[] | undefined;

    constructor(data?: IPackage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sellPrice = _data["sellPrice"];
            this.includedTransactionCount = _data["includedTransactionCount"];
            this.additionalTransactionPrice = _data["additionalTransactionPrice"];
            this.useFixedPrice = _data["useFixedPrice"];
            this.defaultTransactionCountingPeriod = _data["defaultTransactionCountingPeriod"];
            this.useWithPartner = _data["useWithPartner"];
            this.useWithCustomer = _data["useWithCustomer"];
            this.useWithLicenseOwnerCustomerOverride = _data["useWithLicenseOwnerCustomerOverride"];
            this.useWithPartnerCustomerOverride = _data["useWithPartnerCustomerOverride"];
            this.useWithLicenseOwner = _data["useWithLicenseOwner"];
            this.externalProductId = _data["externalProductId"];
            this.partnerId = _data["partnerId"];
            this.partner = _data["partner"] ? Partner.fromJS(_data["partner"]) : undefined as any;
            if (Array.isArray(_data["packageModules"])) {
                this.packageModules = [] as any;
                for (let item of _data["packageModules"])
                    this.packageModules!.push(PackageModule.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Package {
        data = typeof data === 'object' ? data : {};
        let result = new Package();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sellPrice"] = this.sellPrice;
        data["includedTransactionCount"] = this.includedTransactionCount;
        data["additionalTransactionPrice"] = this.additionalTransactionPrice;
        data["useFixedPrice"] = this.useFixedPrice;
        data["defaultTransactionCountingPeriod"] = this.defaultTransactionCountingPeriod;
        data["useWithPartner"] = this.useWithPartner;
        data["useWithCustomer"] = this.useWithCustomer;
        data["useWithLicenseOwnerCustomerOverride"] = this.useWithLicenseOwnerCustomerOverride;
        data["useWithPartnerCustomerOverride"] = this.useWithPartnerCustomerOverride;
        data["useWithLicenseOwner"] = this.useWithLicenseOwner;
        data["externalProductId"] = this.externalProductId;
        data["partnerId"] = this.partnerId;
        data["partner"] = this.partner ? this.partner.toJSON() : undefined as any;
        if (Array.isArray(this.packageModules)) {
            data["packageModules"] = [];
            for (let item of this.packageModules)
                data["packageModules"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPackage {
    id?: number;
    name: string;
    sellPrice?: number;
    includedTransactionCount?: number;
    additionalTransactionPrice?: number;
    useFixedPrice?: boolean;
    defaultTransactionCountingPeriod?: TransactionCountingPeriodType;
    useWithPartner?: boolean;
    useWithCustomer?: boolean;
    useWithLicenseOwnerCustomerOverride?: boolean;
    useWithPartnerCustomerOverride?: boolean;
    useWithLicenseOwner?: boolean;
    externalProductId?: string | undefined;
    partnerId?: number | undefined;
    partner?: Partner | undefined;
    packageModules?: PackageModule[] | undefined;
}

export class PackageModule implements IPackageModule {
    id?: number;
    packageId?: number;
    moduleId?: number;
    module?: Module | undefined;

    constructor(data?: IPackageModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.packageId = _data["packageId"];
            this.moduleId = _data["moduleId"];
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : undefined as any;
        }
    }

    static fromJS(data: any): PackageModule {
        data = typeof data === 'object' ? data : {};
        let result = new PackageModule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["packageId"] = this.packageId;
        data["moduleId"] = this.moduleId;
        data["module"] = this.module ? this.module.toJSON() : undefined as any;
        return data;
    }
}

export interface IPackageModule {
    id?: number;
    packageId?: number;
    moduleId?: number;
    module?: Module | undefined;
}

export class CreatePackageRequest implements ICreatePackageRequest {
    name?: string;
    sellPrice?: number;
    includedTransactionCount?: number;
    additionalTransactionPrice?: number;
    useFixedPrice?: boolean;
    useWithPartner?: boolean;
    useWithCustomer?: boolean;
    useWithLicenseOwnerCustomerOverride?: boolean;
    useWithPartnerCustomerOverride?: boolean;
    useWithLicenseOwner?: boolean;
    defaultTransactionCountingPeriod?: TransactionCountingPeriodType;
    externalProductId?: string | undefined;
    partnerId?: number | undefined;

    constructor(data?: ICreatePackageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sellPrice = _data["sellPrice"];
            this.includedTransactionCount = _data["includedTransactionCount"];
            this.additionalTransactionPrice = _data["additionalTransactionPrice"];
            this.useFixedPrice = _data["useFixedPrice"];
            this.useWithPartner = _data["useWithPartner"];
            this.useWithCustomer = _data["useWithCustomer"];
            this.useWithLicenseOwnerCustomerOverride = _data["useWithLicenseOwnerCustomerOverride"];
            this.useWithPartnerCustomerOverride = _data["useWithPartnerCustomerOverride"];
            this.useWithLicenseOwner = _data["useWithLicenseOwner"];
            this.defaultTransactionCountingPeriod = _data["defaultTransactionCountingPeriod"];
            this.externalProductId = _data["externalProductId"];
            this.partnerId = _data["partnerId"];
        }
    }

    static fromJS(data: any): CreatePackageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePackageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sellPrice"] = this.sellPrice;
        data["includedTransactionCount"] = this.includedTransactionCount;
        data["additionalTransactionPrice"] = this.additionalTransactionPrice;
        data["useFixedPrice"] = this.useFixedPrice;
        data["useWithPartner"] = this.useWithPartner;
        data["useWithCustomer"] = this.useWithCustomer;
        data["useWithLicenseOwnerCustomerOverride"] = this.useWithLicenseOwnerCustomerOverride;
        data["useWithPartnerCustomerOverride"] = this.useWithPartnerCustomerOverride;
        data["useWithLicenseOwner"] = this.useWithLicenseOwner;
        data["defaultTransactionCountingPeriod"] = this.defaultTransactionCountingPeriod;
        data["externalProductId"] = this.externalProductId;
        data["partnerId"] = this.partnerId;
        return data;
    }
}

export interface ICreatePackageRequest {
    name?: string;
    sellPrice?: number;
    includedTransactionCount?: number;
    additionalTransactionPrice?: number;
    useFixedPrice?: boolean;
    useWithPartner?: boolean;
    useWithCustomer?: boolean;
    useWithLicenseOwnerCustomerOverride?: boolean;
    useWithPartnerCustomerOverride?: boolean;
    useWithLicenseOwner?: boolean;
    defaultTransactionCountingPeriod?: TransactionCountingPeriodType;
    externalProductId?: string | undefined;
    partnerId?: number | undefined;
}

export class UpdatePackageRequest implements IUpdatePackageRequest {
    name?: string;
    sellPrice?: number;
    includedTransactionCount?: number;
    additionalTransactionPrice?: number;
    useFixedPrice?: boolean;
    useWithPartner?: boolean;
    useWithCustomer?: boolean;
    useWithLicenseOwnerCustomerOverride?: boolean;
    useWithPartnerCustomerOverride?: boolean;
    useWithLicenseOwner?: boolean;
    defaultTransactionCountingPeriod?: TransactionCountingPeriodType;
    externalProductId?: string | undefined;
    partnerId?: number | undefined;

    constructor(data?: IUpdatePackageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sellPrice = _data["sellPrice"];
            this.includedTransactionCount = _data["includedTransactionCount"];
            this.additionalTransactionPrice = _data["additionalTransactionPrice"];
            this.useFixedPrice = _data["useFixedPrice"];
            this.useWithPartner = _data["useWithPartner"];
            this.useWithCustomer = _data["useWithCustomer"];
            this.useWithLicenseOwnerCustomerOverride = _data["useWithLicenseOwnerCustomerOverride"];
            this.useWithPartnerCustomerOverride = _data["useWithPartnerCustomerOverride"];
            this.useWithLicenseOwner = _data["useWithLicenseOwner"];
            this.defaultTransactionCountingPeriod = _data["defaultTransactionCountingPeriod"];
            this.externalProductId = _data["externalProductId"];
            this.partnerId = _data["partnerId"];
        }
    }

    static fromJS(data: any): UpdatePackageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePackageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sellPrice"] = this.sellPrice;
        data["includedTransactionCount"] = this.includedTransactionCount;
        data["additionalTransactionPrice"] = this.additionalTransactionPrice;
        data["useFixedPrice"] = this.useFixedPrice;
        data["useWithPartner"] = this.useWithPartner;
        data["useWithCustomer"] = this.useWithCustomer;
        data["useWithLicenseOwnerCustomerOverride"] = this.useWithLicenseOwnerCustomerOverride;
        data["useWithPartnerCustomerOverride"] = this.useWithPartnerCustomerOverride;
        data["useWithLicenseOwner"] = this.useWithLicenseOwner;
        data["defaultTransactionCountingPeriod"] = this.defaultTransactionCountingPeriod;
        data["externalProductId"] = this.externalProductId;
        data["partnerId"] = this.partnerId;
        return data;
    }
}

export interface IUpdatePackageRequest {
    name?: string;
    sellPrice?: number;
    includedTransactionCount?: number;
    additionalTransactionPrice?: number;
    useFixedPrice?: boolean;
    useWithPartner?: boolean;
    useWithCustomer?: boolean;
    useWithLicenseOwnerCustomerOverride?: boolean;
    useWithPartnerCustomerOverride?: boolean;
    useWithLicenseOwner?: boolean;
    defaultTransactionCountingPeriod?: TransactionCountingPeriodType;
    externalProductId?: string | undefined;
    partnerId?: number | undefined;
}

export class UserLookupViewModel implements IUserLookupViewModel {
    id?: number;
    name?: string;
    email?: string;

    constructor(data?: IUserLookupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UserLookupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserLookupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        return data;
    }
}

export interface IUserLookupViewModel {
    id?: number;
    name?: string;
    email?: string;
}

export class OpaGetUserResultUser implements IOpaGetUserResultUser {
    email?: string;
    hasAcceptedEndUserLicenseAgreement?: boolean;
    id?: number;
    userRoles?: { [key: string]: number; };
    customerUserRoles?: { [key: string]: OpaGetUserResultCustomerUserRole; };
    customerCorporationRoles?: { [key: string]: OpaGetUserResultCustomerCorporationRole; };

    constructor(data?: IOpaGetUserResultUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.hasAcceptedEndUserLicenseAgreement = _data["hasAcceptedEndUserLicenseAgreement"];
            this.id = _data["id"];
            if (_data["userRoles"]) {
                this.userRoles = {} as any;
                for (let key in _data["userRoles"]) {
                    if (_data["userRoles"].hasOwnProperty(key))
                        (this.userRoles as any)![key] = _data["userRoles"][key];
                }
            }
            if (_data["customerUserRoles"]) {
                this.customerUserRoles = {} as any;
                for (let key in _data["customerUserRoles"]) {
                    if (_data["customerUserRoles"].hasOwnProperty(key))
                        (this.customerUserRoles as any)![key] = _data["customerUserRoles"][key] ? OpaGetUserResultCustomerUserRole.fromJS(_data["customerUserRoles"][key]) : new OpaGetUserResultCustomerUserRole();
                }
            }
            if (_data["customerCorporationRoles"]) {
                this.customerCorporationRoles = {} as any;
                for (let key in _data["customerCorporationRoles"]) {
                    if (_data["customerCorporationRoles"].hasOwnProperty(key))
                        (this.customerCorporationRoles as any)![key] = _data["customerCorporationRoles"][key] ? OpaGetUserResultCustomerCorporationRole.fromJS(_data["customerCorporationRoles"][key]) : new OpaGetUserResultCustomerCorporationRole();
                }
            }
        }
    }

    static fromJS(data: any): OpaGetUserResultUser {
        data = typeof data === 'object' ? data : {};
        let result = new OpaGetUserResultUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["hasAcceptedEndUserLicenseAgreement"] = this.hasAcceptedEndUserLicenseAgreement;
        data["id"] = this.id;
        if (this.userRoles) {
            data["userRoles"] = {};
            for (let key in this.userRoles) {
                if (this.userRoles.hasOwnProperty(key))
                    (data["userRoles"] as any)[key] = (this.userRoles as any)[key];
            }
        }
        if (this.customerUserRoles) {
            data["customerUserRoles"] = {};
            for (let key in this.customerUserRoles) {
                if (this.customerUserRoles.hasOwnProperty(key))
                    (data["customerUserRoles"] as any)[key] = this.customerUserRoles[key] ? this.customerUserRoles[key].toJSON() : undefined as any;
            }
        }
        if (this.customerCorporationRoles) {
            data["customerCorporationRoles"] = {};
            for (let key in this.customerCorporationRoles) {
                if (this.customerCorporationRoles.hasOwnProperty(key))
                    (data["customerCorporationRoles"] as any)[key] = this.customerCorporationRoles[key] ? this.customerCorporationRoles[key].toJSON() : undefined as any;
            }
        }
        return data;
    }
}

export interface IOpaGetUserResultUser {
    email?: string;
    hasAcceptedEndUserLicenseAgreement?: boolean;
    id?: number;
    userRoles?: { [key: string]: number; };
    customerUserRoles?: { [key: string]: OpaGetUserResultCustomerUserRole; };
    customerCorporationRoles?: { [key: string]: OpaGetUserResultCustomerCorporationRole; };
}

export class OpaGetUserResultCustomerUserRole implements IOpaGetUserResultCustomerUserRole {
    customerId?: number;
    customerName?: string;
    hasAcceptedLicenseAgreement?: boolean;
    hasActiveLicense?: boolean;
    roles?: { [key: string]: string; };

    constructor(data?: IOpaGetUserResultCustomerUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.hasAcceptedLicenseAgreement = _data["hasAcceptedLicenseAgreement"];
            this.hasActiveLicense = _data["hasActiveLicense"];
            if (_data["roles"]) {
                this.roles = {} as any;
                for (let key in _data["roles"]) {
                    if (_data["roles"].hasOwnProperty(key))
                        (this.roles as any)![key] = _data["roles"][key];
                }
            }
        }
    }

    static fromJS(data: any): OpaGetUserResultCustomerUserRole {
        data = typeof data === 'object' ? data : {};
        let result = new OpaGetUserResultCustomerUserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["hasAcceptedLicenseAgreement"] = this.hasAcceptedLicenseAgreement;
        data["hasActiveLicense"] = this.hasActiveLicense;
        if (this.roles) {
            data["roles"] = {};
            for (let key in this.roles) {
                if (this.roles.hasOwnProperty(key))
                    (data["roles"] as any)[key] = (this.roles as any)[key];
            }
        }
        return data;
    }
}

export interface IOpaGetUserResultCustomerUserRole {
    customerId?: number;
    customerName?: string;
    hasAcceptedLicenseAgreement?: boolean;
    hasActiveLicense?: boolean;
    roles?: { [key: string]: string; };
}

export class OpaGetUserResultCustomerCorporationRole implements IOpaGetUserResultCustomerCorporationRole {
    corporationId?: string;
    corporationName?: string;

    constructor(data?: IOpaGetUserResultCustomerCorporationRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.corporationId = _data["corporationId"];
            this.corporationName = _data["corporationName"];
        }
    }

    static fromJS(data: any): OpaGetUserResultCustomerCorporationRole {
        data = typeof data === 'object' ? data : {};
        let result = new OpaGetUserResultCustomerCorporationRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["corporationId"] = this.corporationId;
        data["corporationName"] = this.corporationName;
        return data;
    }
}

export interface IOpaGetUserResultCustomerCorporationRole {
    corporationId?: string;
    corporationName?: string;
}

/** Available statuses:<br/>0: InitialSyncing<br/>1: InitialSyncFailed<br/>2: CreatingDefaultGlAccounts<br/>3: CreatingDefaultGlAccountsFailed<br/>4: RecreatingDefaultGlAccounts<br/>5: New<br/>6: Active<br/>7: ScheduledForDeletion<br/>8: ScheduledForPurge<br/>9: AdminPurge<br/>10: Purging<br/>11: PurgingFailed<br/>12: Initial<br/>13: Final */
export enum CustomerStateMachineStatus {
    InitialSyncing = "InitialSyncing",
    InitialSyncFailed = "InitialSyncFailed",
    CreatingDefaultGlAccounts = "CreatingDefaultGlAccounts",
    CreatingDefaultGlAccountsFailed = "CreatingDefaultGlAccountsFailed",
    RecreatingDefaultGlAccounts = "RecreatingDefaultGlAccounts",
    New = "New",
    Active = "Active",
    ScheduledForDeletion = "ScheduledForDeletion",
    ScheduledForPurge = "ScheduledForPurge",
    AdminPurge = "AdminPurge",
    Purging = "Purging",
    PurgingFailed = "PurgingFailed",
    Initial = "Initial",
    Final = "Final",
}

export class VismaBusinessSettings implements IVismaBusinessSettings {
    transactionNumber?: number;

    constructor(data?: IVismaBusinessSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionNumber = _data["TransactionNumber"];
        }
    }

    static fromJS(data: any): VismaBusinessSettings {
        data = typeof data === 'object' ? data : {};
        let result = new VismaBusinessSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TransactionNumber"] = this.transactionNumber;
        return data;
    }
}

export interface IVismaBusinessSettings {
    transactionNumber?: number;
}

export class TwoFourSevenSettings implements ITwoFourSevenSettings {
    transactionNumber?: number;
    transactionType?: number;

    constructor(data?: ITwoFourSevenSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionNumber = _data["TransactionNumber"];
            this.transactionType = _data["TransactionType"];
        }
    }

    static fromJS(data: any): TwoFourSevenSettings {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFourSevenSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TransactionNumber"] = this.transactionNumber;
        data["TransactionType"] = this.transactionType;
        return data;
    }
}

export interface ITwoFourSevenSettings {
    transactionNumber?: number;
    transactionType?: number;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function getTraceParent(span: Span) {
  return `00-${span.spanContext().traceId}-${span.spanContext().spanId}-0${Number(span.spanContext().traceFlags || TraceFlags.NONE).toString(16)}`;
}